<template>
	<!-- <div v-if="dotsLoading" class="mt-2">
		<div class="flex items-center justify-center w-full h-16 skeleton mt-4 tableCornerRadius bg-white">
			<dots-loader/>
		</div>
	</div> -->
	<div class="table-data-root">
		<div class="bg-white table-card-shell" :class="isFrameworksTable ? 'tableCornerRadiusForFramework' : 'tableCornerRadius'">
		<div class="table-card-inner">
			<div class="table-container table-container-fit">
			<div class="table-header-wrap">
			<table class="table-fit-card table-header-table" :style="tableResizeStyle">
				<colgroup>
					<col v-for="presentColumn in columnNames" :key="'h-'+presentColumn" :style="columnStyle(presentColumn)" />
				</colgroup>
				<thead>
					<tr class="table-header-row">
					<th scope="col" v-for="presentColumn in columnNames" :key="presentColumn" :class="getColumnHeadWidth(presentColumn)" class="bg-white capitalize resizable-th" :style="columnStyle(presentColumn)" @click="onHeaderClick(presentColumn)">
						<div class="flex" :class="getPaddingForColumn(presentColumn)" v-if="presentColumn == 'controlscount'||presentColumn == 'no.of controls'||presentColumn =='health'|| presentColumn == 'kpiHealth'|| presentColumn == 'tier'|| presentColumn == 'controlFrequency'" style="justify-content:center">
								<div>
									{{ getColumnLabel(presentColumn) }}
								</div>
							<div class="sort cursor-pointer" :class="className == presentColumn ? classSort : 'opacity-50'" v-if="getColumnLabel(presentColumn) != ''"></div>
						</div>
						<div class="flex" v-else-if="presentColumn == 'publicFacing'" :class="getPaddingForColumn(presentColumn)" style="display:flex;justify-content:center">
							<div>
								{{ getColumnLabel(presentColumn) }}
							</div>
							<div class="sort cursor-pointer" :class="className == presentColumn ? classSort : 'opacity-50'" v-if="getColumnLabel(presentColumn) != ''"></div>
						</div>
						<div v-else-if="presentColumn != 'status' && presentColumn != 'severity' && presentColumn != 'KPIs'">
							<div class="flex" :class="getPaddingForColumn(presentColumn)">
								<div>
									{{ getColumnLabel(presentColumn) }}
								</div>
								<div class="sort cursor-pointer" :class="className == presentColumn ? classSort : 'opacity-50'" v-if="getColumnLabel(presentColumn) != ''"></div>
							</div>
						</div>
						<div v-else class="flex" :class="presentColumn == 'status' || presentColumn == 'severity' || presentColumn == 'KPIs'? 'justify-center' : ''">
							<div class="cursor-pointer">{{ getColumnLabel(presentColumn) }}</div>
							<div class="sort cursor-pointer" :class="className == presentColumn ? classSort : 'opacity-50'" v-if="getColumnLabel(presentColumn) != ''"></div>
						</div>
					<span class="column-resize-handle" @mousedown.stop.prevent="startColumnResize($event, presentColumn)"></span>
					</th>
					</tr>
					<!-- <th scope="col" v-for="column in columnNames" :key="column" :class="getColumnHeadWidth(column)" class="bg-white cursor-pointer capitalize" @click="sort(column)">
						<div class="flex pl-5" v-if="column == 'priority'">
							<div>{{ column }}</div>
						<div class="sort cursor-pointer" :class="className == column && !columnObject ? classSort : 'opacity-50'"></div>
						</div>
						<div class="flex items-center" v-else-if="column == 'complianceId'">
                            <div>{{ "Id" }}</div>
                            <div class="sort cursor-pointer" :class="className == column && !columnObject ? classSort : 'opacity-50'"></div>
                        </div>
                        <div class="flex justify-center items-center" v-else-if="column == 'compliancePeriod'">
                            <div>{{ "Period" }}</div>
                            <div class="sort cursor-pointer" :class="className == column && !columnObject ? classSort : 'opacity-50'"></div>
                        </div>
                        <div class="flex justify-center items-center" v-else-if="column == 'complianceStatus'">
                            <div>{{ "Status" }}</div>
                            <div class="sort cursor-pointer" :class="className == column && !columnObject ? classSort : 'opacity-50'"></div>
                        </div>  
						<div class="flex justify-center items-center" v-else-if="column == 'deleteIcon'">
                        </div> 
						<div
							class="flex justify-center items-center"
							v-else-if="column == 'Date of Target' || column == 'Total Number of Controls' || column == 'KPI\'s' || column == 'Created on' || column == 'frameWorks' || column == 'Target (%)' || column == 'Weightage (%)' || column == 'no.of Kpis' || column == 'weightage (%)'||column=='statusCode'"
						>
							<div>{{ column }}</div>
							<div class="sort cursor-pointer" :class="className == column && !columnObject ? classSort : 'opacity-50'"></div>
						</div>
						<div class="flex" v-else-if="column == 'Status'">
							<div :class="{ 'pl-8': column == 'Status' }">{{ column }}</div>
							<div class="sort cursor-pointer" :class="className == column && !columnObject ? classSort : 'opacity-50'"></div>
						</div>
						<div class="flex w-24" v-else-if="column == 'Target Time Period' || column == 'targetTimePeriod' || column == 'Reporting Frequency' || column == 'reportingFrequency'">
							<div>{{ column }}</div>
							<div class="sort cursor-pointer pl-4" :class="className == column && !columnObject ? classSort : 'opacity-50'"></div>
						</div>
						<div class="flex pl-5" v-else-if="column == 'startDate'">
							<div>{{ column }}</div>
							<div class="sort cursor-pointer pl-4" :class="className == column && !columnObject ? classSort : 'opacity-50'"></div>
						</div>
						<div class="flex" v-else>
							<div>{{ column }}</div>
							<div class="sort cursor-pointer" :class="className == column && !columnObject ? classSort : 'opacity-50'"></div>
						</div>
					</th> -->
					<tr v-if="visibility" class="table-filter-row">
						<td v-for="(name, index) in columnNames" class="bg-white" :key="index" :class="[name === 'status'|| name == 'health' || name == 'kpiHealth' || name== 'tier'|| name == 'controlFrequency' ? 'text-center' : '',getFilterStyles(name)]" :style="columnStyle(name)">
							<select class="priorityStyles m-auto" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-if="name == 'priority'" v-model="filters[name]">
								<option :value="filters.name" selected disabled hidden>Select</option>
								<option class="optionColors" v-for="(value, index) in dbPriority" :key="index" :value="value.value">{{ value.key }}</option>
							</select>
							<select class="severityStyles m-auto" :class="filters[name] == null ? 'inputboxstylingForSelect flex items-center justify-center' : 'stylingForInputboxstylingForSelect'" v-else-if="name == 'severity'" v-model="filters[name]">
								<option :value="filters.name" selected disabled hidden>Select</option>
								<option class="optionColors" v-for="(value, index) in dbSeverity" :key="index" :value="value.value">{{ value.key }}</option>
							</select>
							<select class="resizeComplianceStatus" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-else-if="name == 'complianceStatus'" v-model="filters[name]">
								<option :value="filters.name" selected disabled hidden>Select</option>
								<option class="optionColors" v-for="option in getComplianceStatusOptions()" :key="option.id" :value="option.id">{{ option.value }}</option>
							</select>
							<select :class="filters[name] == null ? 'inputboxstylingForSelect criticalitystyling' : 'stylingForInputboxstylingForSelect criticalitystyling'" class="widthForTypeSelect" v-model="filters[name]" v-if="name=='Type'" >
                                <option :value="filters.name" selected hidden disabled>Select</option>
                                <option class="optionColors" v-for="pair in projectTypeOptions" :key="pair" :value="pair.id">{{ pair.value }}</option>
                                <!-- <option class="optionColors" v-for="value in getCriticalityOptions()" :key="value.id" :value="value.id">{{ value.value }}</option> -->
                            </select>
							<div v-else-if="name == 'statusCode'" class="flex justify-center">
								<select class="priorityStyles" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filters[name]">
									<option :value="filters.name" selected disabled hidden>Select</option>
									<option class="optionColors" v-for="option in statuses" :key="option.id" :value="option.id">{{ option.label }}</option>
								</select>
						    </div>
							<div v-else-if="name == 'capastatusCode'" class="flex justify-center">
								<select class="priorityStyles" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filters[name]">
									<option :value="filters.name" selected disabled hidden>Select</option>
									<option class="optionColors" v-for="option in capaStatuses" :key="option.id" :value="option.id">{{ option.label }}</option>
								</select>
						    </div>
							<select v-else-if="name == 'health'" v-model="filters[name]" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" class="widthforHealthSelect">
								<option :value="filters.name" selected hidden disabled>Select</option>
								<option class="optionColors" v-for="option in getCriticalityOptions()" :key="option.id" :value="option.id">{{ option.value }}</option>
							</select>
							<select v-else-if="name == 'kpiHealth'" v-model="filters[name]" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" class="widthforStatusSelect">
								<option :value="filters.name" selected hidden disabled>Select</option>
								<option class="optionColors" v-for="pair in kpiHealthValues" :key="pair.id" :value="pair.id">{{ pair.value }}</option>
							</select>
							<select class="inputboxstylingForSelect resize" v-else-if="name == 'Status'" v-model="filters[name]">
								<option :value="filters.name" selected disabled hidden>Select</option>
								<option v-for="(value, index) in status" :key="index" :value="value">{{ value }}</option>
							</select>
							<select class="widthForCriticalitySelect" v-else-if="name == 'criticality'" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filters[name]">
								<option :value="filters.name" selected disabled hidden>Select</option>
								<option class="optionColors" v-for="value in dbProcessCriticality" :key="value.value" :value="value.value">{{ value.key }}</option>
							</select>
							<select class="inputboxstylingForSelect resize" v-model="filters[name]" v-else-if="name == 'Target Time Period' || name == 'targetTimePeriod' || name == 'Reporting Frequency' || name == 'reportingFrequency'">
								<option :value="filters.name" selected hidden disabled>Select</option>
								<option v-for="(pair, index) in controlRecurringArray" :key="index" :value="pair.id">{{ pair.label }}</option>
							</select>
							<select v-else-if="name == 'controlPriority'"  class="widthForSelect" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filters[name]">
								<option :value="filters.name" selected disabled hidden>Select</option>
								<option class="optionColors" v-for="pair in dbPriority" :key="pair" :value="pair.value">{{ pair.key }}</option>
							</select>
							<select v-else-if="name == 'type'"  class="widthForSelect" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filters[name]">
								<option :value="filters.name" selected disabled hidden>Select</option>
								<option class="optionColors" v-for="pair in taskType" :key="pair" :value="pair.id">{{ pair.value }}</option>
							</select>
							<select v-else-if="name == 'controlFrequency' || name == 'Frequency'"  class="widthForSelect" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filters[name]">
								<option :value="filters.name" selected disabled hidden>Select</option>
								<option class="optionColors" v-for="pair in dbFrequency" :key="pair" :value="pair.value">{{ pair.key }}</option>
							</select>
							<select v-else-if="name == 'tier'"  class="widthForTierSelect" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-model="filters[name]">
								<option :value="filters.name" selected disabled hidden>Select</option>
								<option class="optionColors" v-for="pair in entityValues" :key="pair" :value="pair.id">{{ pair.value }}</option>
							</select>
							 <select v-else-if="name=='status'" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" class="widthforStatusSelect" v-model="filters[name]">
								<option :value="select" selected hidden disabled>Select</option>
                                <option class="optionColors" v-for="pair in activeValues" :key="pair" :value="pair.id" >{{ pair.value }}</option>
                            </select>
							<select v-model="filters[name]" :class="filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" class="widthforStatusSelect" v-else-if="name == 'publicFacing'">
								<option :value="filters.name" selected hidden disabled>Select</option>
								<option class="optionColors" v-for="pair in publicFacingOptions" :key="pair" :value="pair.id">{{ pair.value }}</option>
							</select>
							
							<div v-else-if=" name == 'actionButtonAtCompliance' || name == 'actionButtonAtObjective' || name == 'actionButtonForKPIs' || name == 'compliancePeriod' || name == 'TotalNumberofControls'||name=='target (%)'||name=='Target'  || name == 'No. of Controls' || name == 'no.of controls' || name == 'weightage (%)' || name == 'frameWorks'|| name == 'no.of Kpis' || name == 'Weightage (%)' || name == 'Date of Target' || name == 'startDate' || name == 'dueDate' || name == 'completedDate' || name == 'createdAt' || name == 'createdOn'|| name=='endDate' || name=='Date of Target' || name=='KPIs' || name == 'No. of Controls' || name == 'kpiDelete' || name == 'deleteIcon'|| name=='status'|| name=='severity'|| name=='priority'||name=='complianceStatus'||name=='controlscount'||name=='publicFacing' || name=='kpiId'"></div>
							<input v-else-if = " name == 'Id' " type="text" class="inputboxstylingForControlID" placeholder="Search" v-model="filters[name]" />
							<input type="text" placeholder="Search" v-else class="searchForInputBoxStyling" v-model="filters[name]" />
						</td>
						<td v-if="tabelActionBtn"></td>
					</tr>
				</thead>
			</table>
			</div>
			<div class="table-body-scroll">
			<table class="table-fit-card" :style="tableResizeStyle">
				<colgroup>
					<col v-for="presentColumn in columnNames" :key="'b-'+presentColumn" :style="columnStyle(presentColumn)" />
				</colgroup>
			    <tbody v-if="loadData == true">
                    <tr class="cursor-pointer empty rowHeight">
                        <td class="relative h-5" :colspan="columnNames.size">
                            <div class="flex items-center justify-center w-full h-16 skeleton">
								<dots-loader/>
                            </div>
                        </td>
                    </tr>
                </tbody>
				<tbody v-else-if="sortedData.length == 0 " class="emptyFixed">
					<tr class="cursor-pointer rowHeight">
						<td class="relative h-10" :colspan="columnNames.size">
							<div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
						</td>
					</tr>
               </tbody>
				<tbody v-else class="tbodylast">
					<tr v-for="(row, index) in sortedData" :key="row" class="cursor-pointer hoverEffectForCompleteRow">
						<td v-for="column in columnNames" :key="column" @mouseout="doFalse()" @click="showBlockAction(row, index, column)" class="cursor-pointer relative" :class="[getColumnHeadWidth(column), column == 'priority'|| column == 'status'|| column=='tier'|| column=='controlFrequency'|| column=='kpiHealth' ? 'text-center' : '']" :style="columnStyle(column)">
							<div v-if="(column == 'Target Time Period' || column == 'targetTimePeriod' || column == 'Reporting Frequency' || column == 'reportingFrequency') && typeof row[column] === 'number'">
								<div>
									{{
										controlRecurringArray.find((l) => {
											return l.id == row[column];
										}).label
									}}
								</div>
							</div>
							<div v-else-if="column == 'Date of Target' || column == 'KPI\'s' || column == 'Created on' || column == 'frameWorks' || column == 'Target (%)' || column == 'Weightage (%)' || column == 'no.of Kpis' || column=='weightage (%)' || column=='TotalNumberofControls'||column=='target (%)'||column=='Target'">
								<div class="center-content">{{row[column]}}</div>
							</div>
							<div class="flex" v-else-if="column == 'startDate'">
								<div class="center-content">{{row[column]}}</div>

							</div>
							<div v-else-if="column =='dueDate'" class="flex justify-center items-center w-20 rounded h-5" :class="shouldStyleDueDate(row) ? colorForDueDate(row[column]) : ''">
								{{ row[column] }} 
							</div>
							<div v-else-if="column == 'compliancePeriod'|| column=='projectOwner'">
								{{row[column]}}
							</div>
							<div v-else-if="column == 'deleteIcon'||column == 'kpiDelete'">
								<div class="flex justify-center items-center">
									<img src="@/assets/deleteIcon.svg" class="cursor-pointer" @click="emitDeleteRowEvent(row,index)"/>
								</div>
							</div>
							<div v-else-if="column == 'team'">
								<div class="table-ellipsis">
									<div @mousemove="toolTip(column, $event, index, row, 'text')">
										{{ getTeamName(row[column]) }}
									</div>
								</div>
							</div>
							<div v-else-if="column == 'type'">
								<!-- <a @click="navigate(row, option, column)" class="anchorUnderline">{{row[column]}}</a> -->
								 {{getTaskType(row[column]) }}
							</div>
							<div v-else-if="column == 'controlFrequency' || column=='Frequency'">
								<div class="table-ellipsis">
									<div @mousemove="toolTip(column, $event, index, row, 'text')">
										{{ getFrequency(row[column]) }}
									</div>
								</div>
							</div>
							<div v-else-if="column == 'health'">
								<div class="flex justify-center" v-if="row[column] == 'N/A'||row[column]==undefined||row[column]==null||row[column]===''">
									<div>N/A</div>
								</div>
								<div v-else class="rounded-full w-5 h-5 mx-auto" 
									@mousemove="toolTip(column, $event, index, row, 'circleButton')" 
									:class="colorEffectivenessBg(row[column])?.color">
								</div>
							</div>
							<div v-else-if="column == 'kpiHealth'">
								<div class="flex justify-center" v-if="row[column] == 'N/A'||row[column]==undefined">
									<div>N/A</div>
								</div>
								<div v-else-if="row[column] == 'Pass'" class="rounded-full w-5 h-5 bg-active mx-auto"
									@mousemove="toolTip(column, $event, index, row, 'circleButton')">
								</div>
								<div v-else-if="row[column] == 'No Instances'" class="rounded-full w-5 h-5 bg-disabledgrey mx-auto"
									@mousemove="toolTip(column, $event, index, row, 'circleButton')">
								</div>
								<div v-else class="rounded-full w-5 h-5 bg-error mx-auto"
									@mousemove="toolTip(column, $event, index, row, 'circleButton')">
								</div>
							</div>
							<div v-else-if="column == 'tier'">
								<div class="table-ellipsis">
									<div @mousemove="toolTip(column, $event, index, row, 'text')">
										{{ getTierName(row[column]) }}
									</div>
								</div>
							</div>
							<div v-else-if="column == 'entity'">
								<p class="cursor-pointer text-xs">{{ getLocationName(row[column]) }}</p>
							</div>
							<div v-else-if="column == 'No. of Controls'" class="center-content">
								<a>{{row[column]}}</a>
							</div>
							<!-- <div v-else-if="column == 'Entity'">
								<p class="cursor-pointer text-xs">{{ getEntityName(row[column]) }}</p>
							</div> -->
							<div v-else-if="column == 'statusCode'" class="flex items-center justify-center">
								<div class="flex items-center justify-center rounded h-5 w-28" :class="bgColorForFindingStatus(row[column])">
									<div :class="textColorForFindingStatus(row[column])">
										<!-- {{row[column]}} -->
										<!-- {{ row[column]  }} -->
										{{getStatusLabelFromColumn(row[column],column)}}
									</div>
								</div>
							</div>
							<div v-else-if="column == 'capastatusCode'" class="flex items-center justify-center">
								<div class="flex items-center justify-center rounded h-5 w-28" :class="bgColorForFindingStatus(row[column])">
									<div :class="textColorForFindingStatus(row[column])">
										<!-- {{row[column]}} -->
										<!-- {{ row[column]  }} -->
										{{getStatusLabelFromColumn(row[column],column)}}
									</div>
								</div>
							</div>
							<div v-else-if="column == 'status'">
                                <div class="rounded-full w-5 h-5 bg-active mx-auto" @mousemove="toolTip(column, $event, index, row, 'circleButton')" v-if="row[column] == 1"></div>
									<div class="rounded-full w-5 h-5 bg-error mx-auto" @mousemove="toolTip(column, $event, index, row, 'circleButton')" v-else></div>
									<div class="flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none" v-if="row[column] == true && pop == true">
										<img src="@/assets/tooltip.svg" alt="" class="absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3" />
										<span class="text-black text-center text-xs"></span>
										Active
									</div>
									<div class="flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none cursor-pointer" v-if="row[column] == false && pop == true">
										<img src="@/assets/tooltip.svg" alt="" class="absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3" />
										<span class="text-black text-center text-xs"></span>
										Inactive
									</div>
                            </div>
							<div v-else-if="column == 'KPIs'" class="flex justify-center items-center">
								<!-- <a @click="navigate(row, option, column)" class="anchorUnderline">{{row[column]}}</a> -->
								 {{ row[column] }}
							</div>
							<div v-else-if="column == 'controlscount'" class="flex justify-center items-center">
								<!-- <a @click="navigate(row, option, column)" class="anchorUnderline">{{row[column]}}</a> -->
								 {{ row[column] }}
							</div>
							<!-- <div v-else-if="column == 'publicFacing'" style="display:flex;justify-content:center">
								<div class="table-ellipsis">
										{{ row[column] == 1 ? 'Yes' : 'No' }}
								</div>
							</div> -->
							<!-- <div v-else-if="column === 'no.of controls'">
								<div class="pl-9 kpis-hover" @click.stop="goToSystemControlMappingPage(row)">
									{{row[column]}}
								</div>
							</div> -->
							<div v-else-if="column=='Type'">
                                <div class="table-ellipsis" @mousemove="toolTip(column, $event, index, row, 'text')">
                                    {{ getProjectType(row[column]) }}
								</div>
							</div>
							<div v-else-if="column=='kpiId'">
                                <div class="table-ellipsis" @mousemove="toolTip(column, $event, index, row, 'text')">
                                    {{ row[column] }}
								</div>
							</div>
							<div v-else-if="column=='publicFacing'" class="flex justify-center items-center">
								<div class="table-ellipsis">
									<p class="fullText" @mousemove="toolTip(column, $event, index, row, 'text')">
										{{ getpublicFacing(row[column])}}
									</p>
								</div>
							</div>
							<div v-else-if="column == 'no.of controls'" class="flex justify-center">
								<a>{{row[column]}}</a>
							</div>
							<div v-else-if="column == 'complianceStatus'" class="">
								<div class="flex items-center justify-center rounded h-5 w-24" :class="colorComplianceBg(row[column])">
									<div :class="colorComplianceText(row[column])">
										{{getStatusLabelFromColumn(row[column],column)}}
									</div>
								</div>
							</div>
							<div v-else-if="column == 'criticality'" class="flex items-center justify-center">
								<!-- <div class="flex items-center justify-center rounded h-5 w-28" :class="colorPriorityBg(row[column])">
									<div :class="colorPriorityText(row[column])" class="table-ellipsisForValue" @mousemove="toolTip(column, $event, index, row, 'label')">
										{{getStatusLabelFromColumn(row[column],column)}}
									</div>
								</div> -->
								<div class="flex items-center justify-center rounded h-5 w-28 px-2.5" :class="colorPriorityBg(row[column])">
                                    <div class="table-ellipsisForValue" style="white-space: break-spaces;" :class="colorPriorityText(row[column])" @mousemove="toolTip(column, $event, index, row, 'label')">
										{{getStatusLabelFromColumn(row[column],column)}}
                                    </div>
                                </div>
							</div>
							 <div v-else-if="column == 'severity'">
                                    <div class="relative flex  justify-center items-center regular">
                                        <div class="flex items-center justify-center rounded-full w-5 h-5" @mousemove="toolTip(presentColumn, $event, index, row, 'circle')" :class="colorPropBg('border', row.severity)">
                                            <div class="severityCircle rounded-full" :class="colorPropBg('circle', row.severity)"></div>
                                        </div>
                                    </div>
                            </div>
							<!-- <div v-else-if="column=='criticality'">
                                <div v-if="column == 'severitypreview'">
                                    <div class="relative regular ml-8">
                                        <div class="flex items-center justify-center rounded-full w-5 h-5" :class="colorPropBg('border', row.severitypreview)">
                                            <div class="severityCircle rounded-full" :class="colorPropBg('circle', row.severitypreview)"></div>
                                        </div>
                                    </div> 
                               </div>
                                <div v-else class="flex items-center justify-center rounded h-5 w-28 px-2.5 regular" :class="colorPriorityBg(row[column])">
                                    <div class="table-ellipsisForValue" style="white-space: break-spaces;" :class="colorPriorityText(row[column])" @mousemove="toolTip(column, $event, index, row, 'label')">
										{{getStatusLabelFromColumn(row[column],column)}}
                                    </div>
                                </div>
                            </div> -->
							<div v-else-if="column == 'controlPriority'" class="flex justify-center items-center">
								<div
									class="flex items-center justify-center rounded h-5 w-24"
									:class="colorLabelBg(row[column])"
								>
									<div :class="colorLabelText(row[column])">
										{{ getProirityLabel(row[column]) }}
									</div>
								</div>
								
							</div>
							<div v-else-if="column == 'findingCategory'">
								{{getStatusLabelFromColumn(row[column],column)}}
							</div>
							<div class="flex items-center justify-center rounded h-5 w-28" :class="colorPriorityBg(row[column])" v-else-if="column == 'priority' && typeof row[column] === 'number'">
								<div :class="colorPriorityText(row[column])">
									<div v-if="row[column]">
										{{
											dbPriority.find((l) => {
												return l.value === row[column];
											}).key
										}}
									</div>
									<div v-else>-</div>
								</div>
							</div>
							<!-- Tasks -->
							<div class="flex items-center justify-center rounded h-5 w-28" :class="colorTaskStatusBg(row[column])" v-else-if="column == 'Status'">
								<div :class="colorTaskStatusText(row[column])">
									{{ row[column] }}
								</div>
							</div>
						<div v-else-if="column == 'actionButtonAtCompliance'" class="relative"  style="display: flex;align-items: center;justify-content: center;">
							<Button type="button" icon="pi pi-ellipsis-v" @click="actionButtonToggle($event, index)" style="background-color: white; color: black; border: white;" class="action-button"/>
							<Menu :ref="'menu' + index" :model="actionButtonAtComplianceItems(row)" :popup="true" class="menuWidth"/>
						</div>
						<div v-else-if="column == 'actionButtonForKPIs'">
                            <fieldset>
								<!-- <div 
                                    class="action-button-container relative"
                                    @click.stop="calculateDropdownPosition(row, index, column)"
                                    :data-row-index="index"
                                >
                                    <div class="flex justify-end items-center w-5 h-5 ImageResponsive">
                                    <img src="@/assets/ActionIcon.svg" class="h-5 w-5 cursor-pointer" />
                                    </div>
                                    
                                    <ul
                                    v-if="showBlock && showBlockindex === index"
                                    class="card shadow-sm absolute cursor-pointer z-50 actionButtonStyling"
                                    :class="[
                                        dropdownDirection[index] === 'up' ? 'dropdown-up' : 'dropdown-down',
                                        'min-w-[150px]'
                                    ]"
                                    >
                                    <li class="cursor-pointer lastChild border-lightgrey hover:bg-lightgrey h-7 flex items-center" v-for="(option, index) in activeControlOptions" @click="optionClickedOnActionControls(option.value,row)" :key="index" >
										<div class="flex items-center" v-if="option.displayIcon == 'deleteIcon'">
											<img src="@/assets/deleteIcon.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
											{{ option.value }}
										</div>
										<div class="flex items-center" v-if="option.value == 'KPI'">
											<img src="@/assets/link.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
                                            {{ option.value }}
                                        </div>
                                    </li>
                                    </ul>
                                </div> -->
								<Button type="button" icon="pi pi-ellipsis-v" @click="actionButtonToggle($event, index)" style="background-color: white; color: black; border: white;" class="action-button"/>
								<Menu :ref="'menu' + index" :model="actionButtonForKPIsItems(row)" :popup="true" class="menuWidth"/>
							</fieldset>
                        </div>
						<div v-else-if="column == 'actionButtonAtObjective'" style="display: flex;align-items: center;justify-content: center;">
							<fieldset>
								<!-- <div 
								class="action-button-container relative"
								@click.stop="calculateDropdownPosition(row, index, column)"
								:data-row-index="index"
								>
								<div class="flex justify-end items-center w-5 h-5 ImageResponsive">
									<img src="@/assets/ActionIcon.svg" class="h-5 w-5 cursor-pointer" @click="calculateDropdownPosition($event, index, column)" />
								</div>
								
								<ul class="card shadow-sm zIndexingForActionDropDown absolute cursor-pointer actionButtonStyling" 
 									class="card shadow-sm absolute cursor-pointer z-50 actionButtonStyling"
                                    :class="[
                                        dropdownDirection[index] === 'up' ? 'dropdown-up' : 'dropdown-down',
                                        'min-w-[150px]'
                                    ]" 
									v-if="showBlock && showBlockindex === index">
									<li class="cursor-pointer lastChild border-lightgrey hover:bg-lightgrey h-7 flex items-center" 
										v-for="(option, index) in objectiveOptions" @click="optionClickedOnActionObjective(option.value, row)" 
										:key="index">
								
									
									<div class="flex items-center" v-if="option.value == 'Select'">
										<img src="@/assets/link.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
										{{ option.value }}
									</div>
									</li>
								</ul>
								</div> -->
								<!-- <div 
                                    class="action-button-container relative"
                                    @click.stop="calculateDropdownPosition(row, index, column)"
                                    :data-row-index="index"
                                >
                                    <div class="flex justify-end items-center w-5 h-5 ImageResponsive">
                                    <img src="@/assets/ActionIcon.svg" class="h-5 w-5 cursor-pointer" />
                                    </div>
                                    
                                    <ul
                                    v-if="showBlock && showBlockindex === index"
                                    class="card shadow-sm absolute cursor-pointer z-50 actionButtonStyling"
                                    :class="[
                                        dropdownDirection[index] === 'up' ? 'dropdown-up' : 'dropdown-down',
                                        'min-w-[150px]'
                                    ]"
                                    >
                                    <li class="cursor-pointer lastChild border-lightgrey hover:bg-lightgrey h-7 flex items-center" 
										v-for="(option, index) in objectiveOptions" @click="optionClickedOnActionObjective(option.value, row)" 
										:key="index">
									<div class="flex items-center" v-if="option.value == 'Select'">
										<img src="@/assets/link.svg" class="mx-2.5 cursor-pointer h-5 w-5 " />
										{{ option.value }}
									</div>
									</li>
                                    </ul>
                                </div> -->
								<Button type="button" icon="pi pi-ellipsis-v" @click="actionButtonToggle($event, index)" style="background-color: white; color: black; border: white;" class="action-button"/>
								<Menu :ref="'menu' + index" :model="actionButtonAtObjectiveItems(row)" :popup="true" class="menuWidth"/>
							</fieldset> 
							</div>
							<div v-else>
								<div class="table-ellipsis">
									<p class="fullText" @mousemove="toolTip(column, $event, index, row, 'text')">
										<!-- <div v-if="column == 'KPIs'" class="ml-2">{{ row[column] }}</div> -->
										{{ row[column] }}
									</p>
								</div>
								<!-- </div> -->
								
							</div>
						</td>
						<td class="cursor-pointer " v-if="tabelActionBtn">
							<div class="flex justify-end h-5 ImageResponsive">
								<img src="@/assets/ActionIcon.svg" @click="calculateDropdownPosition($event, index,'outerAction')" class="h-5 w-5 cursor-pointer" />
							</div>
							<!-- <ul class="card ml-2 shadow-sm z-30 absolute cursor-pointer" :class="isNearBottom(index)|| index == 0 ? 'dropdown-up' : ''" v-if="showBlock && showBlockindex === index && this.$route.path.includes('/root-Frameworks')" style="right: 0px; margin-right: 50px; position: absolute">
								<li class="cursor-pointer py-2 hover:bg-lightgrey h-7 w-24 flex items-center" v-for="(option, index) in tableRouteArr" :key="index">
									<div class="flex items-center" v-if="option.displayIcon == 'deleteIcon'" @click="openPopup(row, index, 'actionBtn')">
										<img src="@/assets/deleteIcon.svg" class="h-4 w-4 mx-2.5" />
										{{ option.value }}
									</div>
									<div class="flex items-center" v-else-if="option.displayIcon == 'mapIcon'" @click="navigate(row, option)">
										<img src="@/assets/link.svg" class="h-4 w-4 mx-2.5" />
										{{ option.value }}
									</div>
								</li>
							</ul> -->
							<!-- <ul :class="isNearBottom(index) ? 'dropdown-up' : ''" class="card ml-2 shadow-sm zIndexingForActionDropDown absolute cursor-pointer" v-if="showBlock && showBlockindex == index && this.$route.path.includes('/compliance')">
                                    <li class="cursor-pointer lastChild border-b border-lightgrey hover:bg-lightgrey h-7 flex items-center " v-for="(option, index) in tableRouteArr" @click="optionClickedOnAction(option.value,row)" :key="index" >
                                        <div class="flex items-center" v-if="option.value == 'Edit'">
                                            <img src="@/assets/editIcon.svg" class="mx-1.5 cursor-pointer h-5 w-5 mx-2.5" />
                                            {{ option.value }}
                                        </div>
                                        <div class="flex items-center" v-if="option.value == 'View'">
                                            <img src="@/assets/view.svg" class="mx-1.5 cursor-pointer h-5 w-5 mx-2.5" />
                                            {{ option.value }}
                                        </div>
                                        <div class="flex items-center" v-if="option.value == 'Start'">
                                            <img src="@/assets/Findings.svg" class="mx-1.5 cursor-pointer h-5 w-5 mx-2.5" />
                                            {{ option.value }}
                                        </div>
                                        <div class="flex items-center" v-if="option.value == 'Findings'">
                                            <img src="@/assets/Findings.svg" class="mx-1.5 cursor-pointer h-4 w-4 mx-2.5" />
                                            {{ option.value }}
                                        </div>
                                        <div class="flex items-center" v-if="option.value == 'Controls'">
                                            <img src="@/assets/controls.svg" class="mx-1.5 cursor-pointer h-5 w-5 mx-2.5" />
                                            {{ option.value }}
                                        </div>
                                        <div class="flex items-center" v-if="option.value == 'Reports'">
                                            <img src="@/assets/reports.svg" class="mx-1.5 cursor-pointer h-5 w-5 mx-2.5" />
											{{ option.value }}
										</div>
									</li>
								</ul> -->
							<ul class="card shadow-sm z-30 absolute cursor-pointer" :class="isNearBottom(index)|| index == 1 ? 'dropdown-up1' : 'zIndexingForActionDropDown2'" :style="isNearBottom(index) ? {} : {left: dynamicLeftPosition + 'px',top: dynamicTopPosition + 'px',display: showDropDown ? 'block' : 'none'}"  v-if="showBlock && showBlockindex === index" style="right: 0px; margin-right: 61px; position: absolute">
								<li class="cursor-pointer py-2 hover:bg-lightgrey h-7 w-24 flex items-center" v-for="(option, index) in tableRouteArr" :key="index" @click="navigate(row, option)">
									<div class="flex items-center">
										<img src="@/assets/link.svg" class="h-4 w-4 mx-2.5" />
										{{ option.value }}
									</div>
								</li>
							</ul>
						</td>
					</tr>
				</tbody>
			</table>
			</div>
			</div>
			<pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :sortedData="sortedData"></pagination>
		</div>
		</div>
	</div>
</template>
<style scoped>
.action-button-container {
  position: relative;
  display: inline-block;
}
.widthForPublicFacing{
    width:12%;
}
.widthTwentyFivePercent{
	width: 24%;
}
.widthForTierSelect{
	width: 85px;
}
.widthForActivities{
    width:30%
}
.widthTenPercent{
    width:10%;
}
/* Dropdown positioning classes */
.dropdown-up {
  bottom: calc(100% + 5px);
  position: absolute;
  right: 0;
  z-index: 999;
  background: white;
  min-width: 150px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.dropdown-down {
  top: calc(100% + 5px);
  position: absolute;
  right: 0;
  z-index: 999;
  background: white;
  min-width: 150px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.table-ellipsisForValue {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Card and list item styling */
.card {
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 100px;
  width: max-content;
}

.card li {
  padding: 8px 12px;
  white-space: nowrap;
  border-bottom: 1px solid #e9e9e9;
}

.card li:hover {
  background-color: #f5f5f5;
}

.card li:last-child {
  border-bottom: none;
}

/* Keep your existing table styles */
.lastChild:last-child {
    border: 0px;
}
.table-container {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}
.main-table{
  min-width: 855px;
}
.resizable-th {
	position: relative;
}
.column-resize-handle {
	position: absolute;
	top: 0;
	right: 0;
	width: 6px;
	height: 100%;
	cursor: col-resize;
	user-select: none;
	z-index: 2;
}
.table-data-root {
	display: flex;
	flex-direction: column;
	flex: 1 1 auto;
	height: auto;
	max-height: 100%;
	min-height: 0;
	overflow: hidden;
}
.table-card-shell {
	display: flex;
	flex-direction: column;
	flex: 0 1 auto;
	width: 100%;
	max-height: 100%;
	min-height: 0;
	overflow: hidden;
}
.table-card-inner {
	display: flex;
	flex-direction: column;
	flex: 0 1 auto;
	max-height: 100%;
	min-height: 0;
	overflow: hidden;
}
.table-card-inner > :last-child {
	flex-shrink: 0;
}
.table-container-fit {
	width: 100%;
	max-width: 100%;
	display: flex;
	flex-direction: column;
	flex: 0 1 auto;
	max-height: 100%;
	min-height: 0;
	overflow: hidden;
}
.table-header-wrap {
	flex-shrink: 0;
	overflow-x: hidden;
	overflow-y: scroll;
	scrollbar-gutter: stable;
	scrollbar-width: thin;
	scrollbar-color: transparent transparent;
}
.table-header-wrap::-webkit-scrollbar {
	width: 6px !important;
}
.table-header-wrap::-webkit-scrollbar-track {
	background: transparent !important;
}
.table-header-wrap::-webkit-scrollbar-thumb {
	background: transparent !important;
}
.table-body-scroll {
	flex: 0 1 auto;
	min-height: 0;
	overflow-x: hidden;
	overflow-y: auto;
	overscroll-behavior: contain;
	scrollbar-gutter: stable;
	scrollbar-width: thin;
	scrollbar-color: #c4c4c4 transparent;
	background: #ffffff;
}
.table-body-scroll::-webkit-scrollbar {
	width: 6px !important;
}
.table-body-scroll::-webkit-scrollbar-track {
	background: transparent !important;
}
.table-body-scroll::-webkit-scrollbar-thumb {
	background: #c4c4c4 !important;
	border-radius: 4px !important;
}
.mapping-inline-table .table-data-root,
.details-in-modal.mapping-modal .table-data-root {
	height: auto;
	flex: 0 1 auto;
	max-height: 100%;
}
.mapping-inline-table .table-card-shell,
.mapping-inline-table .table-card-inner,
.mapping-inline-table .table-container-fit,
.mapping-inline-table .table-body-scroll,
.details-in-modal.mapping-modal .table-card-shell,
.details-in-modal.mapping-modal .table-card-inner,
.details-in-modal.mapping-modal .table-container-fit,
.details-in-modal.mapping-modal .table-body-scroll {
	flex: 0 1 auto;
	max-height: 100%;
	min-height: 0;
}
.table-fit-card {
	table-layout: fixed;
	border-collapse: collapse;
	border-spacing: 0;
}
.table-header-table {
	width: auto;
	border-collapse: separate;
	border-spacing: 0;
}
.table-header-table thead tr:first-child,
.table-header-table thead tr.table-header-row {
	border-top: none !important;
}
.table-header-table thead tr.table-header-row th,
.table-header-table thead tr:first-child th {
	border-top: none !important;
	border-bottom: 1px solid var(--color-lightgrey) !important;
	box-shadow: none !important;
}
.table-header-table thead tr.table-filter-row,
.table-header-table thead tr:nth-child(2) {
	border-top: none !important;
}
.table-header-table thead tr.table-filter-row td,
.table-header-table thead tr:nth-child(2) td {
	border-top: none !important;
	border-bottom: 1px solid var(--color-lightgrey) !important;
}
.table-body-scroll tbody tr:first-child {
	border-top: none !important;
}
table {
  table-layout: fixed;
  border-collapse: collapse;
  /* min-width: 1000px; as per your widest layout */
}
th, td {
  white-space: nowrap;/* prevent wrapping */
  text-overflow: ellipsis;
}
.inputboxstylingForSelect .optionColors{
   color : #4D4D4D !important;
}
/* .anchorUnderline:hover{
	color: #1976d2;
	text-decoration: underline;
	text-decoration-thickness: 3px;
    font-weight: bold;
} */
.fullText{
    white-space: break-spaces;
    font-size: 12px;
}
.zIndexingForActionDropDown{
    z-index : 50;
    width : 100px;
    margin-left : -20px;
}
.centerNoData {
    font-size: 12px;
    height: 60px;
    padding: 0px 20px;
    color: black;
    border-top: 1px solid #e9e9e9;
}
.pendingEvidence{
    background-color: #8600f040;
}

.tbodylast:last-child {
	border-bottom: 1px solid #e9e9e9;
}
.priorityStyles{
  width : 112px;
}
.severityStyles{
	width : 80px;
}
.widthForSelect{
    width : 100px !important;
}
.widthforStatusSelect{
	width: 100%;
}
.widthforHealthSelect{
	width:75px;
}
.widthForCriticalitySelect{
	width:130px;
}
.kpis-hover:hover {
	color: #119BB9;
    text-decoration: underline;
	text-decoration-thickness: 3px;
    font-weight: bold;
}
.table-ellipsis {
  display:-webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
 .actionButtonWidth{
	width : 60px;
 }
 .zIndexingForActionDropDown{
	z-index : 50;
	width : 100px;
	margin-left : -40px;
	position: absolute;
	left: -9px;
}
.zIndexingForActionDropDown1{
	z-index : 50;
	width : 100px;
	margin-left : -40px;
	position: fixed;
}
.zIndexingForActionDropDown2{
	z-index : 50;
	width : 100px;
	margin-left : -40px;
	position: fixed;
}
.findingWidth{
	width : 400px;
}
.widthOfEntity{
	width: 15%;
}
.widthOfComplianceId{
	width: 10%;
}
.widthOfComplianceTitle{
	width: 20%;
}
.widthOfComplianceStartDate{
	width: 10%;
}
.widthElevenpercent{
	width: 10%;
}
.widthFifteenpercent{
	width: 15%;
}
.widthOfComplianceStatus{
	width: 10%;
}
.widthOfCompliancePeriod{
	width: 15%;
}
.widthThreePercent{
	width: 3%;
}
.widthTenPercent{
	width: 10%;
}
.resizeComplianceStatus{
	width:100px ! important;
}
.widthOfComplianceActionButton{
	width: 8%;
}
.widthfivePercent{
	width: 5%;
}
.bgDisabledGrey{
	background-color: rgba(164, 164, 164, 0.2);
}
.bgError{
	background-color: rgba(255, 0, 0, 0.2);
}
.bgdarkred{
	background-color: rgba(192, 0, 0, 0.2);
}
.bgYellow{
	background-color: rgba(255, 153, 0, 0.2);
}
.bgprimary{
	background-color: rgba(25, 118, 210, 0.2);
}
.bgLightGreen{
	background-color: rgba(0, 176, 80, 0.2);
}
.bgGreen{
	background-color: rgba(146, 208, 80, 0.2);
}
.bgElectricGreen{
	background-color: rgba(134, 0, 240, 0.2);
}
.bgForReview{
	background-color: rgba(8, 91, 150, 0.2);
}
.bgPrimary{
	background-color: rgba(21, 42, 67, 0.2);
}
/* Disabled Grey: rgba(164, 164, 164, 0.2)
Error: rgba(255, 0, 0, 0.2)
Dark Red: rgba(192, 0, 0, 0.2)
Yellow: rgba(255, 153, 0, 0.2)
Green: rgba(146, 208, 80, 0.2)
Light Green: rgba(0, 176, 80, 0.2)
Primary: rgba(21, 42, 67, 0.2)
Electric Green: rgba(134, 0, 240, 0.2)
For Review: rgba(8, 91, 150, 0.2) */
</style>
<style>
body.col-resizing {
	cursor: col-resize !important;
	user-select: none !important;
}
</style>
<script lang="ts">
import { emitter, toast } from '@/main';
import _ from 'lodash';
import { defineComponent } from 'vue';
import toolTip from '@/components/toolTip.vue';
import pagination from '@/components/pagination.vue';
import useVuelidate from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import Multiselect from "vue-multiselect";
import Button from 'primevue/button';
import { mapGetters } from 'vuex';
import dotsLoader from '@/components/dotsLoader.vue';

import Menu from 'primevue/menu';
export default defineComponent({
	props: ['tableRowData', 'tabelActionBtn', 'tableRouteArr', 'departmentArr', 'headersData', 'locations','loadData','columnWidthPreset'],
	data(): any {
		return {
			v$: useVuelidate(),
			tableHead: [],
			dropdownDirection:{},
			tableRow: [],
			searchTableRow: [],
			entityId: '',
			visibility: false,
			className: '',
			classSort: '',
			currentSort: 'name',
			currentSortDir: 'asc',
            allEntities:[],
			entitiesArray:[],
			currentPage: '',
			pageSize: '',
			dynamicPagination: '',
			showBlockindex: '',
			showBlock: false,
			isDropdownUp: false,
			showDropdown: false,
			optionRoute: '',
			columnWidths: {},
			resizingColumn: null,
			resizeStartX: 0,
			resizeStartWidth: 0,
			didResize: false,
			columns: [
                { key: 'complianceId', value: 'ID' },
				{ key: 'kpiId', value: 'KPI ID' },
				{ key:'completedDate',value:'completed On'},
				{key:'type',value:'Task Type'},
				{ key:'dueDate',value:'due Date'},
                { key: 'title', value: 'Title' },
				{ key: 'controlImportTitle', value: 'Title' },
				{ key: 'activeControlsTitle', value: 'Title' },
				{ key: 'KPItitle', value: 'Title' },
				{ key: 'frameworkTitle', value: 'Title' },
                { key: 'compliancePeriod', value: 'Period' },
                { key: 'startDate', value: 'Start Date' },
                { key: 'endDate', value: 'End Date' },
                { key: 'reviewer', value: 'Reviewer' },
                { key: 'complianceStatus', value: 'Status' },
				{ key: 'findingId', value: 'ID' },
				{key:'CRID',value:'CR ID'},
				{key:'findingCapaId',value:'Finding Id'},
				{ key: 'taskId', value: 'ID' },
				{ key: 'taskStatus', value: 'status' },
				{ key: 'findingComment', value: 'finding' },
				{ key: 'complianceName', value: 'Compliance' },
				{ key: 'findingCategory', value: 'Category' },
				{ key: 'teamName', value: 'team' },
				{ key: 'entityName', value: 'entity' },
				{ key: 'controlNumber', value: 'Number' },
                { key: 'controlName', value: 'title' },
                { key: 'statusCode', value: 'Status' },
				{ key: 'capastatusCode', value: 'Status' },
                { key: 'frameworks', value: 'framework' },
                { key: 'no.of Kpis', value: 'KPIs' },
				{ key: 'createdAt', value: 'Created At' },
				{ key: 'createdOn', value: 'Created On' },
				{ key: 'systemName', value: 'system' },
				{key:  'publicFacing',value:'Internet Facing?'},
				{ key: 'vendorCategory', value: 'Vendor Category' },
				{ key: 'sytemCategory', value: 'Category' },
				{ key: 'EntityofActivity', value: 'Location' },
				{ key: 'activityTeam', value: 'Team' },
				{ key: 'complianceReviewer', value: 'Team Leader' },
				{ key: 'complianceTitle', value: 'Title' },
				{ key: 'viewComplianceEntity', value: 'Location' },
				{ key: 'viewComplianceTeam', value: 'Team' },
				{ key: 'viewComplianceFindingTeam', value: 'Team' },
				{ key: 'viewCompliancefinding', value: 'Finding' },
				{ key: 'viewComplianceFindingId', value: 'Id' },
				{ key: 'objectiveEntity', value: 'Location' },
				{ key: 'objectiveDepartment', value: 'Team' },
				{ key: 'TotalNumberofControls', value: 'Controls' },
				{ key: 'KPI Name', value: "Name" },
				{ key: 'clientUniqueId', value: "CID" },
				{ key: 'controlPriority', value: "Priority" },
				{ key: 'controlOwner', value: "Owner" },
				{key:'entity',value:'Location'},
				{key:'teamOwner',value:'Team Representative'},
				{key:'Entity',value:'Location'},
				{key:'controlFrequency',value:'Frequency'},
				{key:'tierTitle',value:'Scope'},
				{key:'updatedon',value:'Updated On'},
				{key:'projectOwner',value:'Owner'},
				{key:'entityDisplayName',value:'Location'},
				{key:'controlscount',value:'Controls'},
				{key:'No. of Controls',value:'Controls'},
				{key:'Activity Owner',value:'Owner'},
				{key:'no.of controls',value:'Controls'},
				{key:'Activities',value:'Activity'},
				{key:'department',value:'Team'},
				{key:'controlTitle',value:'control Title'},
				{key:'kpiHealth',value:'KPI Health'},
				{key:'Date of Target',value:'Target Date'},
            ],
			pop: false,
			styling: { left: '', bottom: '' },
			tipText: '',
			tipColumn: '',
			tipIndex: '',
			filters: {},
			actionBtn: false,
            dynamicLeftPosition: 0,
            dynamicTopPosition: 0,
			columnObject: false,
			columnValueObj: [],
			allOptionNames: [],
			users: [],
			statuses:[],
			capaStatuses:[],
			optionsUserArray: [],
			controlRecurring: ['Yearly', 'Half-Yearly', 'Quarterly', 'Monthly', 'Weekly', 'Daily'],
			controlFrequencyArray: [
				{ label: 'Daily', id: 1 },
				{ label: 'Weekly', id: 2 },
				{ label: 'Monthly', id: 3 },
				{ label: 'Quarterly', id: 4 },
				{ label: 'Semi Annualy', id: 5 },
				{ label: 'Annualy', id: 6 },
				{ label: 'Transactional', id: 7 },
			],
			taskType:[
				{
					id:20501,
					value:'Task'
				},
				{
					id:20502,
					value:'Sub Task'
				}
			],
			priorityArray: [
				{ label: 'Very Low', id: 1 },
				{ label: 'Low', id: 2 },
				{ label: 'Moderate', id: 3 },
				{ label: 'High', id: 4 },
				{ label: 'Critical', id: 5 }
			],
			activeValues: [
				{
					id: 1,
					value: 'Active'
				},
				{
					id: 2,
					value: 'Inactive'
				}
			],
			kpiHealthValues: [
				{
					id: 'Pass',
					value: 'Pass'
				},
				{
					id: 'Fail',
					value: 'Fail'
				},
				{
					id: 'No Instances',
					value: 'No Instances'
				}
			],
			entityValues: [
				{
					id: 10108,
					value: 'System'
				},
				{
					id: 10107,
					value: 'Activity'
				},{
					id:10109,
					value:'Project'
				}
			],
			projectTypeOptions : [
				{
					id:10703,
					value:'Customer',
				},
				{
					id:10704,
					value:'Internal',
				}
			],
			publicFacingOptions : [
				{
					id:1,
					value:'Yes',
				},
				{
					id:2,
					value:'No',
				}
			],
			 actionButtonAtComplianceItems(row:any) {
				return [
					{
					label: 'Edit',
					icon: 'pi pi-pencil',
					command: () => this.optionClickedOnAction('Edit', row)
					},
					{
					label: 'View',
					icon: 'pi pi-eye',
					command: () => this.optionClickedOnAction('View', row)
					},
					{
					label: 'Controls',
					icon: 'pi pi-cog',
					command: () => this.optionClickedOnAction('Controls', row)
					},
					{
					label: 'Reports',
					icon: 'pi pi-file',
					command: () => this.optionClickedOnAction('Reports', row)
					}
				];
			},
			actionButtonForKPIsItems(row:any){
				return [
					{
						label: 'KPI',
						icon: 'pi pi-link',
						command: () => this.optionClickedOnActionControls('KPI', row)
					}
					

				]
			},
			actionButtonAtObjectiveItems(row:any){
				return[
					{
						label:'Select',
						icon:'pi pi-link',
						command: () => this.optionClickedOnActionObjective('Select', row)

					}
				]
			},
			status: ['Open', 'Closed'],
			controlRecurringArray: [
				{ label: 'Daily', id: 1 },
				{ label: 'Weekly', id: 2 },
				{ label: 'Monthly', id: 3 },
				{ label: 'Quarterly', id: 4 },
				{ label: 'Half-Yearly', id: 5 },
				{ label: 'Yearly', id: 6 }
			],
			dropdownOptions:[
                {
                    key: 'complianceStatus',
                    value: [
                       {
                            id: 10401,
                            value: 'Not started'
                        },
                        {
                            id: 10402,
                            value: 'In progress'
                        },
                        {
                            id: 10403,
                            value: 'Closed'
                        },
						{
							id: 10418,
							value: 'Terminated'
						}
                    ]
               
                },
				{
                    key: 'controlhealth',
                    value: [
                       	{ value: 'Critical', id: 1 },
						{ value: 'ILL', id: 2 },
						{ value: 'Moderate', id: 3 },
						{ value: 'Good', id: 4 },
						{ value: 'Healthy', id: 5 }
                    ]
               
                },
                {
                    key: 'taskStatus',
					value: [
                        {
                            id: 10401,
                            value: 'Not Started'
                        },
                        {
                            id: 10414,
                            value: 'Pending Evidence'
                        },
                        {
                            id: 10421,
                            value: 'In Review'
                        },
                        {
                            id: 10416,
                            value: 'Evidence Uploaded'
                        },
                        {
                            id: 10403,
                            value: 'Completed'
                        },
                        
						{
                            id: 10419,
                            value: 'For Review'
                        },
                        {
                            id: 10418,
                            value: 'Terminated'
                        },
 
                    ]
 
               
                },
				{
					key: 'statusCode',
                    value: [
                        {
                            id: 10401,
                            value: 'Open'
                        },
                        {
                            id: 10402,
                            value: 'In Progress'
                        },
                        {
                            id: 10408,
                            value: 'Approval'
                        },
                        {
                            id: 10419,
                            value: 'For Review'
                        },
                        {
                            id: 10421,
                            value: 'In Review'
                        },
                        {
                            id: 10403,
                            value: 'Completed'
                        },
						{
                            id: 10406,
                            value: 'Partial'
                        },
						{
							id: 10418,
							value: "Terminated",
						},
						{
							id:10420,
							value:"Failed"
						}
                    ]
 
				},
                {	
                    key:'findingCategory',
                    value: [
                        {
                            id: 1,
                            value: 'Minor'
                        },
                        {
                            id: 2,
                            value: 'Major'
                        },
                        {
                            id: 3,
                            value: 'OFI'
                        },
                        {
                            id: 4,
                            value: 'Observation'
                        }
                    ]
                }
            ],
			// optionsValue: [
            //     {
            //         id: 1,
            //         label: 'Edit',
			// 		 command: () => this.optionClickedOnAction('Edit', row)
            //     },
            //     {
            //         id: 2,
            //         label: 'View',
            //     },
            //     {
            //         id: 5,
            //         label: 'Controls',
            //     },
			// 	{
			// 		id: 6,
			// 		label	: 'Reports',
			// 	}
            // ],
			objectiveOptions:[
			    {
                    id: 1,
                    value: 'Select',
                },
			],
			// activeControlOptions:[
			// {
            //         id: 1,
            //         value: 'KPI',
            //     },
			// ]
		};
	},
	// validations() {
	// 	return {
	// 		sortedData: {
	// 			$each: helpers.forEach({
	// 				reviewer: { required },
	// 				teamOwner: { required }
	// 			})
	// 		}
	// 	};
	// },
	components: {
        pagination,
        Multiselect,
		dotsLoader,
		Menu,
		Button
    },
	async mounted() {
		this.optionRoute = this.$route.path;
		this.initialize();
		// await this.getAllUsers();
		// await this.getAllEntities();
		emitter.on('visible', (isBoolean: any) => {
			this.visibility = isBoolean;
			this.visibility == false ? (this.filters = {}) : '';
		});
		emitter.on('*', (type, booleanValue) => {
			if (type == 'apps-sidemenubar' || type == 'toggle-sidebar') {
				this.showBlock == true ? (this.showBlock = false) : '';
			} else {
				if (this.showDropdown === true && type != 'deActiviteToolTip') {
					this.showBlock == true ? (this.showBlock = booleanValue) : '';
				} else if (this.showDropdown === false) {
					this.showBlock == true ? '' : (this.showBlock = booleanValue);
					this.showDropdown = true;
				}
            }
		});
		emitter.on('apps', (isToggle: any) => {
			this.showBlock = isToggle;
		});
		// let path:any = this.$rout.path.includes('/org/compliance')
		// if(path == true){
			
		// }
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('resize', this.clampWidthsToContainer);
        // window.addEventListener('scroll', this.updateDropdownPosition);
		this.handleResize();
	},
	beforeUnmount() {
		this.stopColumnResize();
		window.removeEventListener('resize', this.handleResize);
		window.removeEventListener('resize', this.clampWidthsToContainer);
	},
	beforeDestroy() {
		this.stopColumnResize();
		window.removeEventListener('resize', this.handleResize);
		window.removeEventListener('resize', this.clampWidthsToContainer);
        // window.removeEventListener('scroll', this.updateDropdownPosition);
	},
	computed: {
		isFrameworksTable(): boolean {
			const path = (this.$route.path || '').toLowerCase();
			return path.includes('framework');
		},
		sortedData: function (): any {
			return [...this.tableRow]
				.filter((row: any) => {
					for (const key in this.filters) {
						const inputValue = this.filters[key];
						if (row[key] == 20503 || row[key]==20504) {
							row[key] = 20501;
						}
						if (key === 'health' && Number(inputValue) === 1 && (Number(row[key]) === 0 || Number(row[key]) === 1)) {
							continue;
						}
						if (inputValue !== '' || row[key]) {
							// if (Number.isInteger(row[key])) {
							if (Number(inputValue) && isNaN(row[key])) {
								// console.log('Number(inputValue)', Number(inputValue));
								if (!String(row[key]).includes(inputValue)) {
									return false;
								}
							} else {
								// if (!isNaN(row[key])) {
								// 	return false;
								// } else {
								if(row[key]==null){
									return false;
								}
								if (!row[key].toString().toLowerCase().includes(inputValue.toString().toLowerCase())) {
									return false;
								}
								// }
							}
						}
					}
					return true;
				})
				.sort((a, b) => {
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
					if (this.currentSort === 'health') {
						const healthRank = (row: any) => {
						const value = row.health;
						if (value === 'N/A' || value == null || value === '') return 1;
							return 0;
						};
						const aRank = healthRank(a);
						const bRank = healthRank(b);
						if (aRank < bRank) return -1 * modifier;
						if (aRank > bRank) return 1 * modifier;
						return Number(a.health) - Number(b.health);
					}
                    if(this.currentSort=='taskId' || this.currentSort=='kpiId'){
						const aVal = (a[this.currentSort] ?? '').toString();
						const bVal = (b[this.currentSort] ?? '').toString();
                        const aNumMatch = aVal.match(/\d+$/);
                        const bNumMatch = bVal.match(/\d+$/);
                        if (aNumMatch && bNumMatch) {
                            const aNum = parseInt(aNumMatch[0], 10);
                            const bNum = parseInt(bNumMatch[0], 10);
                            if (aNum < bNum) return -1 * modifier;
                            if (aNum > bNum) return 1 * modifier;
                            return 0;
                        }
						if (aVal < bVal) return -1 * modifier;
						if (aVal > bVal) return 1 * modifier;
                    }
					else if (
						this.currentSort === 'Target' ||
						this.currentSort === 'Target (%)' ||
						this.currentSort === 'target (%)' ||
						this.currentSort === 'Weightage (%)' ||
						this.currentSort === 'weightage (%)'
					) {
						const toNumeric = (val: any) => {
							if (val === 'N/A' || val == null || val === '') return Number.NEGATIVE_INFINITY;
							const num = Number(String(val).replace('%', '').trim());
							return isNaN(num) ? Number.NEGATIVE_INFINITY : num;
						};
						const aNum = toNumeric(a[this.currentSort]);
						const bNum = toNumeric(b[this.currentSort]);
						if (aNum < bNum) return -1 * modifier;
						if (aNum > bNum) return 1 * modifier;
						return 0;
					}
					else{
                        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					    if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                    }
					return 0;
				})
				.filter((row, index) => {
					this.dynamicPagination = index + 1;
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
		},
		// columnNames: function (): any {
		// 	let names = new Set();
		// 	for (let row of this.tableRowData) {
		// 		for (let key of Object.keys(row)) {
		// 			if (key != '_id' && key != 'entityId' && key != 'key' && key != 'metrics' && key != 'isformula' && key != 'description' && key != 'kpis') names.add(key);
		// 		}
		// 		this.checkEmptyValues();
		// 	}
		// 	return names;
		// },
		columnNames: function (): any {
            const names = new Set();
            for (const key of this.headersData) {
                if (key != '_id' && key != 'entityId' && key != 'key' && key != 'metrics' && key != 'isformula' && key != 'description' && key != 'kpis') names.add(key);
            }
            // this.checkEmptyValues();
            return names;
        },
		...mapGetters({
			 userInfo: 'userInfo',
			 dbPriority:'dbPriority',
			 dbSeverity:'dbSeverity',
			 dbProcessCriticality:'dbProcessCriticality',
			 dbFrequency:'dbFrequency'
            //  dotsLoading: 'dotsLoading'
		}),
		tableResizeStyle(): any {
			const names = Array.from(this.columnNames || []) as string[];
			const widths = this.columnWidths || {};
			const measured = names.filter((name: string) => Number(widths[name]) > 0);
			if (!names.length || measured.length !== names.length) {
				return {
					tableLayout: 'fixed',
					width: '100%',
					maxWidth: '100%',
				};
			}
			const containerWidth = this.getContainerWidth();
			const total = names.reduce((sum: number, name: string) => sum + Number(widths[name]), 0);
			const width = Math.min(total, containerWidth);
			return {
				tableLayout: 'fixed',
				width: width + 'px',
				minWidth: width + 'px',
				maxWidth: '100%',
			};
		},
	},
	watch: {
		visibility(newValue) {
			if (newValue == false) {
				this.initialize();
			}
		},
		tableRowData: {
			handler(newVal, oldVal) {
				this.tableRow = this.tableRowData;
				this.initialize();
			},
			deep: true
		}
	},
	async created() {
		await this.getCapaStatuses();
		await this.getFindingsStatuses();
		// this.getAllUsers();
	},
	methods: {
		columnStyle(column: any) {
			const width = this.columnWidths[column];
			if (!width) {
				return {};
			}
			return {
				width: width + 'px',
				minWidth: width + 'px',
				maxWidth: width + 'px',
			};
		},
		snapshotColumnWidths() {
			const headers = this.$el?.querySelectorAll?.('.table-header-table thead th') || [];
			const names = Array.from(this.columnNames || []) as string[];
			const next: Record<string, number> = { ...this.columnWidths };
			headers.forEach((th: HTMLElement, index: number) => {
				const column = names[index];
				if (column && next[column] == null) {
					next[column] = Math.max(60, Math.round(th.getBoundingClientRect().width));
				}
			});
			this.columnWidths = next;
		},
		getContainerWidth() {
			const container =
				(this.$el?.querySelector?.('.table-container-fit') as HTMLElement | null) ||
				(this.$el?.querySelector?.('.table-container') as HTMLElement | null) ||
				(this.$el?.querySelector?.('.table-header-wrap') as HTMLElement | null);
			if (container) {
				return Math.max(60, Math.floor(container.clientWidth || container.getBoundingClientRect().width));
			}
			return Math.max(60, Math.floor(this.$el?.clientWidth || 800));
		},
		maxWidthForColumn(column: string, proposedWidth: number) {
			const names = Array.from(this.columnNames || []) as string[];
			const otherWidth = names.reduce((sum: number, name: string) => {
				if (name === column) {
					return sum;
				}
				return sum + (Number(this.columnWidths[name]) || 60);
			}, 0);
			const containerWidth = this.getContainerWidth();
			const maxTotal = Math.max(60, containerWidth - otherWidth);
			return Math.min(proposedWidth, maxTotal, containerWidth);
		},
		clampWidthsToContainer() {
			const names = Array.from(this.columnNames || []) as string[];
			if (!names.length || !Object.keys(this.columnWidths || {}).length) {
				return;
			}
			const containerWidth = this.getContainerWidth();
			const total = names.reduce((sum: number, name: string) => sum + (Number(this.columnWidths[name]) || 0), 0);
			if (total <= containerWidth) {
				return;
			}
			const scale = containerWidth / total;
			const next: Record<string, number> = { ...this.columnWidths };
			names.forEach((name: string) => {
				if (next[name]) {
					next[name] = Math.max(60, Math.round(next[name] * scale));
				}
			});
			let overflow = names.reduce((sum: number, name: string) => sum + (Number(next[name]) || 0), 0) - containerWidth;
			for (let i = names.length - 1; i >= 0 && overflow > 0; i--) {
				const name = names[i];
				const current = Number(next[name]) || 0;
				if (current > 60) {
					const reduced = Math.max(60, current - overflow);
					overflow -= current - reduced;
					next[name] = reduced;
				}
			}
			this.columnWidths = next;
		},
		applyResizeKeepingRightVisible(column: string, proposedWidth: number) {
			const names = Array.from(this.columnNames || []) as string[];
			const idx = names.indexOf(column);
			if (idx < 0) {
				return { [column]: this.maxWidthForColumn(column, proposedWidth) };
			}
			const containerWidth = this.getContainerWidth();
			const leftWidth = names.slice(0, idx).reduce((sum: number, name: string) => {
				return sum + (Number(this.columnWidths[name]) || 60);
			}, 0);
			const rightNames = names.slice(idx + 1);
			const minRight = rightNames.length * 60;
			const maxForResized = Math.max(60, containerWidth - leftWidth - minRight);
			const nextWidth = Math.min(Math.max(60, proposedWidth), maxForResized, containerWidth);
			const next: Record<string, number> = { ...this.columnWidths, [column]: nextWidth };
			const usedLeftAndResized = leftWidth + nextWidth;
			let remaining = Math.max(0, containerWidth - usedLeftAndResized);
			const currentRightTotal = rightNames.reduce((sum: number, name: string) => {
				return sum + (Number(this.columnWidths[name]) || 60);
			}, 0);
			if (rightNames.length && currentRightTotal > remaining) {
				const scale = remaining / currentRightTotal;
				rightNames.forEach((name: string) => {
					next[name] = Math.max(60, Math.round((Number(this.columnWidths[name]) || 60) * scale));
				});
				let overflow =
					rightNames.reduce((sum: number, name: string) => sum + (Number(next[name]) || 0), 0) - remaining;
				for (let i = rightNames.length - 1; i >= 0 && overflow > 0; i--) {
					const name = rightNames[i];
					const current = Number(next[name]) || 0;
					if (current > 60) {
						const reduced = Math.max(60, current - overflow);
						overflow -= current - reduced;
						next[name] = reduced;
					}
				}
			}
			return next;
		},
		startColumnResize(event: MouseEvent, column: any) {
			this.snapshotColumnWidths();
			this.clampWidthsToContainer();
			const th = (event.currentTarget as HTMLElement)?.closest('th');
			this.resizingColumn = column;
			this.resizeStartX = event.clientX;
			this.resizeStartWidth = this.columnWidths[column] || th?.getBoundingClientRect().width || 60;
			this.didResize = false;
			document.body.classList.add('col-resizing');
			document.addEventListener('mousemove', this.onColumnResize);
			document.addEventListener('mouseup', this.stopColumnResize);
		},
		onColumnResize(event: MouseEvent) {
			if (!this.resizingColumn) {
				return;
			}
			const delta = event.clientX - this.resizeStartX;
			if (Math.abs(delta) > 2) {
				this.didResize = true;
			}
			const rawWidth = Math.max(60, Math.round(this.resizeStartWidth + delta));
			if (delta > 0) {
				this.columnWidths = this.applyResizeKeepingRightVisible(this.resizingColumn, rawWidth);
			} else {
				this.columnWidths = {
					...this.columnWidths,
					[this.resizingColumn]: this.maxWidthForColumn(this.resizingColumn, rawWidth),
				};
			}
		},
		stopColumnResize() {
			this.resizingColumn = null;
			document.body.classList.remove('col-resizing');
			document.removeEventListener('mousemove', this.onColumnResize);
			document.removeEventListener('mouseup', this.stopColumnResize);
			this.clampWidthsToContainer();
		},
		onHeaderClick(column: any) {
			if (this.didResize) {
				this.didResize = false;
				return;
			}
			this.sort(column);
		},
		actionButtonToggle(event:any, index:any) {
			let menu = this.$refs['menu' + index];
			if (Array.isArray(menu)) menu = menu[0];
			if (menu && typeof menu.toggle === 'function') {
				menu.toggle(event);
			}
		},
		shouldStyleDueDate(row:any) {
			const status = row.taskStatus ?? row.statusCode;
			return status != 10403 && status != 10418;
		},
		colorForDueDate(date: string) {
            if (!date) return '';
            const [day, month, year] = date.split('-').map(Number);
            const due = new Date(year, month - 1, day);
            const today = new Date();
            due.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);
           
            if (due < today) {
                return ["bgdarkred border-solid border text-darkred font-semibold flex justify-center items-center text-xs"]
            }
            return '';
        },
		getTierName(id:any){
			let matchedTier = this.entityValues.find((matchId:any)=>matchId.id==id);
			if(matchedTier !=undefined && matchedTier!=''){
				return matchedTier.value
			}
			else{
				return 'N/A'
			}
		},
		getCriticalityName(value:any){
            let obj =  this.dbProcessCriticality.find((l:any) => { return l.value == value; });
            if(obj!=undefined){
                return obj.key
            }else{
                return '-'
            }
        },
		colorPropBg(format: any, scaleScore: any) {
            if (format == 'circle') {
                if (scaleScore == 5) {
                    return ['bg-darkred'];
                } else if (scaleScore == 4) {
                    return ['bg-error'];
                } else if (scaleScore == 3) {
                    return ['bg-yellow'];
                } else if (scaleScore == 2) {
                    return ['bg-green'];
                } else if (scaleScore == 1) {
                    return ['bg-lightgreen'];
                }
            } else if (format == 'border') {
                if (scaleScore == 5) {
                    return ['border-darkred border-4'];
                } else if (scaleScore == 4) {
                    return ['border-error border-4'];
                } else if (scaleScore == 3) {
                    return ['border-yellow border-4'];
                } else if (scaleScore == 2) {
                    return ['border-green border-4'];
                } else if (scaleScore == 1) {
                    return ['border-lightgreen border-4'];
                }
            }
        },
		 getProjectType(data:any){            
            let relationship = this.projectTypeOptions.find((rel:any)=>rel.id==data)         
            return relationship!=undefined?relationship.value:'N/A'
        },
		async getFindingsStatuses(){
			let appId='10001';
			let entityId='10110';
			await this.$http.get(`${process.env.VUE_APP_AUTH_API}/${appId}/${entityId}/statuses`).then((result: any) => {				
			this.statuses = result.data.statuses
			});
		},
		
		async getCapaStatuses(){
			let appId='10001';
			let entityId='10119';
			await this.$http.get(`${process.env.VUE_APP_AUTH_API}/${appId}/${entityId}/statuses`).then((result: any) => {				
			this.capaStatuses = result.data.statuses
			});
		},
		getpublicFacing(facing:any){
			if(facing==1){
				return 'Yes'
			}
			else if(facing==2){
				return 'No'
			}
			else{
				return 'N/A'
			}
		},
		
		getFrequency(a:any){
            let val = this.dbFrequency.find((item:any)=>{ return item.value == a });
            if(val != undefined){
                return val.key
            }else{
                return 'N/A'
            }
        },
		getEntityValue(entityId:any){
			 let val = this.entityValues.find((item:any)=>{ return item.id == entityId });
            if(val != undefined){
                return val.value
            }else{
                return 'N/A'
            }
		},
		getKpiPageWidths(){
			return {
				kpiId: 'w-[10%] whitespace-nowrap',
				KPI: 'w-[14%] whitespace-nowrap',
				CID: 'w-[10%] whitespace-nowrap',
				controlTitle: 'w-[18%] whitespace-nowrap',
				Team: 'w-[8%] whitespace-nowrap',
				'weightage (%)': 'w-[10%] whitespace-nowrap',
				'target (%)': 'w-[10%] whitespace-nowrap',
				Target: 'w-[10%] whitespace-nowrap',
				kpiHealth: 'w-[10%] whitespace-nowrap',
				status: 'w-[10%] whitespace-nowrap',
			};
		},
		getColumnHeadWidth(column:any){
		 if (this.columnWidthPreset == 'kpi') {
			const kpiPageWidths = this.getKpiPageWidths();
			if (kpiPageWidths[column]) {
				return kpiPageWidths[column];
			}
		 }
		 let ValueKeys:any = ['no.of Kpis','frameWork']
            if(ValueKeys.includes(column)){
               return 'w-32';
            }
			let Values:any = ['Entity','Location']
            if(Values.includes(column)){
               return 'w-28';
            }
			let Keys:any = ['compliance title','title','entity','team','entityName','Frequency']
            if(Keys.includes(column)){
               return 'w-36';
            }if(column == 'department'|| column == 'model'||column=='owner'||column=='vendor'||column=='sytemCategory' || column=='tierTitle'||column == 'criticality' || column=='Customer'|| column == 'entityDisplayName'|| column=='projectOwner'||column=='priority'){
				return 'w-[15%]';
			}
			if(column == "Id"|| column == 'no.of Kpis' || column == 'Class'|| column=='TaskId' || column == 'completedDate' || column == 'type'){				
				return 'w-24';
			}if(column == 'dueDate'){
				return 'w-24 flex justify-center items-center'
			}if(column == 'systemName' ||column == 'family'||column=='class'|| column == 'action'){
				return 'w-[20%]'
			}if(column == "deleteIcon" || column=='actionButtonForKPIs'){
				return 'actionButtonWidth';
			}if(column == 'frameworkTitle' || column == 'KPI Name'){
				return 'w-[30%]'
			}if(column == 'vendorCategory'|| column=='Title'|| column=='Title`'){
				return 'w-48'
			}if(column == 'KPItitle'){
				return 'w-52'
			}if(column == 'departments'||column == 'activeControlsTitle'||column == 'viewComplianceEntity'|| column == 'viewComplianceTeam'|| column == 'Team Owner'|| column == 'Reviewer'|| column == 'viewComplianceFindingTeam'|| column == 'entityName'||column=='Project'){
				return 'w-1/5'
			}if(column=='No. of Controls'||column=='health'|| column=='kpiHealth'|| column == 'KPIs'||column == 'createdAt'||column=='number'||column == 'Date of Target' ||column=='TotalNumberofControls'|| column == 'weightage (%)'||column =='target (%)'||column == 'Target'||column == 'CID' ||column=='no.of controls' || column == 'status'||column == 'taskId'|| column=='controlscount'||column=='severity' || column == 'controlOwner'||column=='Team'||column=='kpiId'||column == 'location'||column == 'reviewer'){
				return 'w-[10%]'
			}if(column == 'tier'){
				return 'w-[12%]'
			}if(column == 'statusCode'){
				return 'w-20'
			}if(column=='findingCapaId'){
				return 'w-[10%]'
			}
			if(column == 'Activities'){
                return 'widthForActivities'
            }if(column == 'weightage (%)'||column=='target (%)'||column=='Target'){
				return 'w-1/6'
			}if(column=='Status'){
				return 'w-32'
			}if(column == 'Weightage (%)'){
				return 'w-32'
			}if(column == 'kpiDelete'){
				return 'w-32'
			}if(column == 'finding' ){
				return 'w-44'
			}if(column == 'compliance Title'||column == 'controlTitle'|| column=='KPI'){
				return 'widthTwentyFivePercent'
			}
			if(column=='Name'|| column == 'systemName' ){
				return 'w-36'
			}if(column=='findingId'||column=='createdOn'||column=='CRID'){
				return 'w-16'
			}
			if(column == 'EntityofActivity'||column == 'Activity Owner'||column == 'activityTeam'){
				return 'widthOfEntity'
			}if(column == 'complianceId'){
				return 'widthOfComplianceId'
			}if(column == 'startDate'){
				return 'widthOfComplianceStartDate'
			}if(column == 'complianceTitle'){
				return 'widthOfComplianceTitle'
			}if(column == 'endDate'){
				return 'widthElevenpercent'
			}if(column == 'actionButtonAtCompliance'){
				return 'widthOfComplianceActionButton'
			}if( column=="compliancePeriod"){
				return 'widthOfCompliancePeriod';
			}if(column=="clientUniqueId"||column=='viewComplianceFindingId'){
				return 'widthTenPercent'
			}else if(column=='publicFacing'|| column=='Type'||column=='Time Period'){
                return 'widthForPublicFacing'
            }else if(column == 'complianceStatus'){
				return 'widthOfComplianceStatus'
			}else if(column == 'complianceReviewer'||column == 'controlPriority'||column=='controlFrequency'){
				return 'widthFifteenpercent'
			}else if(column == 'viewCompliancefinding'){
				return 'w-1/2'
			}else if(column=='objective'||column=='objectiveDepartment'||column=='objectiveEntity'||column=='responsibility'|| column == 'TotalNumberofControls'){
				return 'w-24'
			}else if(column == 'actionButtonAtObjective'){
				return 'widthfivePercent justify-center items-center'
			}
			// if(column == 'actionButtonAtCompliance'){
			// 	return 'widthOfComplianceActionButton'
			// }if( column=="compliancePeriod"){
			// 	return 'w-1/5';
			// }
		},
		goToKpisPage(row:any){
			emitter.emit('openDetailsModal', {
				view: 'manageKPI',
				title: row.controlTitle || row.title || 'Control',
				params: { controlId: row._id, type: 10102 },
			});
		},
		goToSystemControlMappingPage(row:any){
			emitter.emit('openDetailsModal', {
				view: 'systemControlMapping',
				title: row.systemName || 'System',
				params: { systemId: row._id },
			});
		},
		getPaddingForColumn(column:any){
            // if(column=='complianceStatus'){
            //     return 'flex justify-center items-center'
            // }
			if(column == 'Date of Target'||column == 'controlPriority' || column == 'priority' || column == 'statusCode'||column=='capastatusCode' || column == 'TotalNumberofControls' || column == 'No. of Controls' || column == 'KPI\'s' || column == 'Created on' || column == 'frameWorks' || column == 'Target (%)' || column == 'Weightage (%)' || column == 'no.of Kpis' || column == 'weightage (%)'||column=='target (%)'||column=='Target'){
				return 'flex justify-center items-center'
			}else if(column == 'criticality' ){
				return 'flex justify-center items-center'
			}
			else if(column == 'departments'){
				return 'w-44'
			}else if( column == 'KPItitle' || (column == 'CID' && this.columnWidthPreset != 'kpi')){
				return 'w-32'
			}
			else if(column == 'complianceTitle'||column == 'activeControlsTitle'){
				return 'w-36'
			}else if(column == 'compliancePeriod'){
				return 'pl-10 w-36'
			}else if(column == 'complianceStatus'){
				return 'pl-6 w-28'
			}
			else if(column == 'startDate'){
				return 'w-20'
			}
			else if(column == 'complianceId'){
				return 'w-28'
			}
			else if(column == 'endDate'||column == 'clientUniqueId'){
				return 'w-16'
			}
			else if(column == 'Reviewer'){
				return 'w-32'
			}
			else if(column == 'actionButtonAtCompliance'|| column=="actionButtonAtObjective"){
				return 'w-8'
			}
			else if(column == 'objective'||column == 'objectiveDepartment'||column == 'objectiveEntity'||column == 'responsibility'){
				return 'w-24'
			}
			else if(column == 'complianceReviewer'){
				return 'w-24'
			}
        },
		getFilterStyles(columnName: any){
			if (columnName == 'controlPriority'){
                return 'flex justify-center items-center';
            }
		},
		getColumnLabel(columnName: any) {
			if (columnName == 'actionButton' || columnName == 'kpiDelete' || columnName == 'deleteIcon' || columnName == 'actionButtonAtCompliance' || columnName == 'actionButtonAtObjective' || columnName=='actionButtonForKPIs'){
                return '';
            }
            const column = this.columns.find((col: { key: any }) => col.key === columnName);
            return column ? column.value : columnName;
        },
		optionForFindingsAction(actionOption: any, rowData: any){
			if(actionOption == 'View'){
				if(rowData._id){
					emitter.emit('openDetailsModal', {
						view: 'findings',
						title: rowData.finding || 'Finding',
						params: { findingId: rowData._id },
					});
				}
            }
		},
		optionForFindingTasksAction(actionOption: any, rowData: any){
			if(actionOption == 'View'){
				if(rowData._id){
					emitter.emit('openDetailsModal', {
						view: 'actionTask',
						title: rowData.action || 'CAPA Task',
						params: { findingId: rowData.linkedFindingId, taskId: rowData._id },
					});
				}
            }
		},
		optionClickedOnActionObjective(actionOption: any, rowData: any){
			if(actionOption == 'Select'){
                emitter.emit('openDetailsModal', {
					view: 'objectiveControls',
					title: rowData.objective || 'Objective',
					params: { objectiveId: rowData._id },
				});
            }
		},
		optionClickedOnActionControls(actionOption: any, rowData: any){
			if(actionOption == 'KPI'){
				if (this.$route.path.includes('/root-Frameworks')) {
					this.$router.push({ name: 'manageRootControlMapping', params: { id: rowData._id }, query: { from: 'frameworks' } });
				} else if (this.$route.path.includes('/root/allControls')) {
					emitter.emit('openDetailsModal', {
						view: 'manageRootControlMap',
						title: rowData.title || rowData.controlTitle || 'Control',
						params: { controlId: rowData._id, from: 'internalControls' },
					});
				} 
				else if(this.$route.path.includes('/org/controls/active')){
					emitter.emit('openDetailsModal', {
						view: 'manageKPI',
						title: rowData.controlTitle || rowData.title || 'Control',
						params: { controlId: rowData._id, type: 10102 },
					});
				}
            }
		},
		optionClickedOnAction(actionOption: any, rowData: any){
            let actionObj:any = {
                action: actionOption,
                data:rowData
            }
            if(rowData['complianceStatus'] == 10401 && actionOption=='Edit'){
				if(rowData.createdBy == this.userInfo._id){
					emitter.emit('openDetailsModal', {
						view: 'editCompliance',
						title: rowData.complianceTitle || rowData.title || 'Edit Compliance',
						params: { complianceId: rowData._id },
					});
				}
				else{
                toast.error('Cannot Edit', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
				}
            }
			else if(actionOption == 'Start'){
                emitter.emit('openDetailsModal', {
					view: 'startCompliance',
					title: rowData.complianceTitle || rowData.title || 'Tasks',
					params: { complianceId: rowData._id },
				});
            }else if(actionOption == 'View'){
				emitter.emit('openDetailsModal', {
					view: 'viewCompliance',
					title: rowData.complianceTitle || rowData.title || 'Compliance',
					params: { complianceId: rowData._id },
				});
			}else if(actionOption == 'Controls'){
				emitter.emit('openDetailsModal', {
					view: 'complianceControls',
					title: rowData.complianceTitle || rowData.title || 'Controls',
					params: { complianceId: rowData._id },
				});
			}else if(rowData['complianceStatus'] == 10418 || rowData['complianceStatus'] == 10402 && actionOption=='Edit'){
				toast.error('Cannot Edit Compliance in this Status', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
			else{
                emitter.emit('clickedOnDropDownAction',actionObj)
            }
        },
		getComplianceStatusOptions() {
            const complianceStatusOption = this.dropdownOptions.find((option:any) => option.key === 'complianceStatus');
            return complianceStatusOption ? complianceStatusOption.value : [];
        },
		getFindingStatusOptions() {
            const findingStatusOption = this.dropdownOptions.find((option:any) => option.key === 'statusCode');
            return findingStatusOption ? findingStatusOption.value : [];
        },
		getCriticalityOptions(){
			const findingStatusOption = this.dropdownOptions.find((option:any) => option.key === 'controlhealth');
            return findingStatusOption ? findingStatusOption.value : [];
		},
		getStatusLabelFromColumn(columnName: any, type: any) {
			if(type=='criticality'){
				const option = this.dbProcessCriticality.find((criticality:any)=>criticality.value==columnName);
				return option ? option.key:[];
			}
			if(type =='statusCode'){
				const option = this.statuses.find((status:any)=>status.id==columnName);
				return option ? option.label:[];
			}
			if(type=='capastatusCode'){
				console.log('2345657',columnName,this.capaStatuses)
				const capaOption = this.capaStatuses.find((status:any)=>status.id==columnName);
				return capaOption ? capaOption.label:[];
			}
			else{
				// console.log('aaa',columnName,type);
				
				 const option = this.dropdownOptions.find((option: { key: any }) => option.key === type);
				//  console.log('aaaddd',option);
				 
				const option1 = option.value.find((soption: { id: any }) => soption.id === columnName);
				return option ? option1.value : [];
			}
        },
		textColorForFindingStatus(status: any) {
            if (status == 10403 || status == 10423) {
                return ['font-semibold text-lightgreen'];
            } else if (status == 10421) {
                return ['font-semibold text-yellow'];
            } else if (status == 10401) {
                return ['font-semibold text-disabledgrey'];
            } else if (status == 10418) {
                return ['font-semibold text-error'];
            } else if(status == 10402){
                return ['font-semibold mx-2 text-electricGreen']
            } else if(status == 10406 || status == 10408){
                return ['font-semibold mx-2 text-primary']
            } else if(status == 10419 || status==10414){
                return ['font-semibold mx-2 text-forReview']
            } else if(status == 10420 || status == 10410){
				return ['font-semibold text-xs mx-2 text-darkred']
			} else {
                return '-'
            }
        },
        bgColorForFindingStatus(status: any) {
            if (status == 10403 || status == 10423) {
                return ['bgLightGreen border-solid border border-lightgreen'];
            } else if (status == 10421) {
                return ['bgYellow border-solid border border-yellow'];
            } else if (status == 10401) {
                return ['bgDisabledGrey border-solid border border-disabledgrey'];
            } else if (status == 10418) {
                return ['bgError border-solid border border-error'];
            } else if (status == 10402) {
                return ['bgElectricGreen border-solid border border-electricGreen'];
            } else if (status == 10406 || status == 10408) {
                return ['bgprimary border-solid border border-primary'];
            }else if (status == 10419 || status == 10414) {
                return ['bgForReview border-solid border border-forReview'];
            }  else if (status == 10420 || status == 10410) { 				
				return ['bg-veryHighColor border-solid border border-darkred'];
			}else {
                return '-'
            }
        },
		colorComplianceText(status: any) {
            if (status == 10401) {
                return ['font-semibold text-disabledgrey'];
            } else if (status == 10402 || status == 10421) {
                return ['font-semibold text-yellow'];
            } else if (status == 10403) {
                return ['font-semibold text-lightgreen'];
            } else if(status == 10414){
                return ['font-semibold mx-2 text-electricGreen']
            } else if(status == 10416){
                return ['font-semibold mx-2 text-primary']
            }else if(status == 10417){
                return ['font-semibold mx-2 text-darkred']
            } else if(status == 10418){
                return ['font-semibold mx-2 text-error']
            }   else if(status == 10420){
				return ['font-semibold text-xs mx-2 text-darkred']
			} 
        },
        colorComplianceBg(status: any) {
			if (status == 10401) {
				return ['bgDisabledGrey border-solid border border-disabledgrey'];
			} else if (status == 10402 || status == 10421) {
				return ['bgYellow border-solid border border-yellow'];
			} else if (status == 10403) {
				return ['bgLightGreen border-solid border border-lightgreen'];
			} else if (status == 10414) {
				return ['bgElectricGreen border-solid border border-electricGreen'];
			} else if (status == 10416) {
				return ['bgPrimary border-solid border border-primary'];
			}else if (status == 10417) {
				return ['bgdarkred border-solid border border-darkred'];
			}else if (status == 10418) {
				return ['bgError border-solid border border-error'];
			}
		},
		async getAllUsers() {
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
				this.users = res.data;
			});
			for (var i = 0; i < this.users.length; i++) {
				this.optionsUserArray.push({ label: this.users[i].name, value: this.users[i]._id });
			}
		},
		// isNearBottom(index:any) {
        //     if(((index == 0))&&((this.sortedData.length == 1))){
        //         return false;
        //     }else{
        //         return index >= this.sortedData.length - 2;
		// 		// return true
        //     }
        // },
		handleResize() {
			const currentWidth = window.innerWidth;
			// Check if the width is less than or equal to 80%
			if (currentWidth >= (window.screen.width * 0.8)) {
				this.showDropDown = false;
			this.showBlock = false // Close the dropdown
			}
			// Repeat for other widths if needed
			else if (currentWidth >= (window.screen.width * 0.7)) {
				this.showDropDown = false;
			}
			else if (currentWidth >= (window.screen.width * 0.6)) {
				this.showDropDown = false;
			}
			else if (currentWidth >= (window.screen.width * 0.5)) {
				this.showDropDown = false;
			}
		},
		// updateDropdownPosition() {
        //     // If the dropdown is open, adjust its position based on the current scroll
		// 	if (this.showDropDown) {
        //         const actionImage = this.$refs.actionImage; // Reference to action image
        //         if (actionImage) {
        //             const rect = actionImage.getBoundingClientRect();
        //             this.dynamicLeftPosition = rect.left - 40; // Adjust if needed
        //             this.dynamicTopPosition = rect.bottom + 15; // Position below the image
        //         }
        //     }
        // },
		calculateDropdownPosition(event:any, index: any, coloum: any) {
			 if (!this.dropdownDirection) {
                    this.dropdownDirection = {};
                }
                this.calculateDropdownDirection(index.toString());
			if(coloum == "actionButtonAtCompliance" || coloum == "actionButtonAtObjective" || coloum == "outerAction" || coloum == 'actionButtonForKPIs'){
				// console.log("this.showBlockindex",this.showBlockindex)
				if (this.showBlockindex === index) {
					this.showBlock = !this.showBlock;
					// console.log("this.showBlock",this.showBlock)
				} else {
					// console.log("showBlockindex", this.showBlockindex)
					this.showBlock = true;
					this.showBlockindex = index;
				}
			}
			this.showDropdown = false;
		},
		calculateDropdownDirection(index: string) {
            const actionButton = document.querySelector(`[data-row-index="${index}"]`);
            if (!actionButton) return;

            const buttonRect = actionButton.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            
            const estimatedDropdownHeight = 80; 
          
            const taskbarBuffer = 50;
            const visibilityBuffer = 20;
            const spaceBelow = windowHeight - buttonRect.bottom - taskbarBuffer;
            this.dropdownDirection[index] = spaceBelow < (estimatedDropdownHeight + visibilityBuffer) ? 'up' : 'down';
        },
		teamOwnerReviewerSame(row: any) {
			// Check if teamOwner and reviewer are defined and if they are the same
			return row.teamOwner && row.reviewer && row.teamOwner === row.reviewer;
		},
		emitDeleteRowEvent(row:any, index: any) {
            // Emit the deleteRowFromTable event with the necessary data
            emitter.emit('deleteKpiRowFromTable', row);
            emitter.emit('deleteRowFromTable', {
                team: row.team,
                entity: row.entity
            });
            emitter.emit('deleteControlFromTable', {
                index: index,
                data: row
            });
        },
        getTeamName(deptId: any) {
            let nameOfTeam = this.departmentArr.find((obj: any) => {
                return obj._id == deptId;
            });
            if (nameOfTeam == undefined) {
                let empty = '';
                return empty;
            } else {
                return nameOfTeam.displayName;
            }
        },
		getTaskType(type: any) {
			let taskTypeData:any;
			if(type==20503 || type == 20504){
				type = 20501
			}
			taskTypeData = this.taskType.find((obj: any) => {
				return obj.id == type;
			});			
            		
            if (taskTypeData == undefined) {
                let empty = 'N/A';
                return empty;
            } else {
                return taskTypeData.value;
            }
        },
 
		getLocationName(locationId: any) {
			let user = this.locations.find((obj: any) => {
				return obj.value == locationId;
			});
			if (user == undefined) {
				let empty = '';
				return empty;
			} else {
				return user.label;
			}
		},
		getEntityName(entity: any) {
			let entityName = this.entitiesArray.find((obj: any) => {
				return obj.value == entity;
			});
			if (entity === 'global' || entity === 'Global') {
				let empty = 'Global';
				return empty;
			} 
			else if(entityName == undefined){
				let name = 'N/A';
				return name;
			}
			else {
				return entityName.label;
			}
		},
		// checkEmptyValues() {
		// 	for (let row of this.tableRowData) {
		// 		for (let value of Object.values(row)) {
		// 			if (value === '') {
		// 				this.columnObject = true;
		// 				return;
		// 			}
		// 		}
		// 	}
		// 	this.columnObject = false;
		// },
		navigate(row: any, option: any, coloum: any) {
			if (this.$route.path.includes('/org/frameworks')) {
				this.$router.push({ name: 'Manage Control Mapping', params: { id: row._id } });
			} else if (this.$route.path.includes('/org/activity/controls')) {
				emitter.emit('openDetailsModal', {
					view: 'departmentControls',
					title: row.Activities || row.businessProcessName || row.displayName || 'Activity',
					params: { id: row._id },
				});
			}
			 else if (this.$route.path.includes('/objective')) {
				emitter.emit('openDetailsModal', {
					view: 'objectiveControls',
					title: row.objective || 'Objective',
					params: { objectiveId: row._id },
				});
            } else if (this.$route.path.includes('/controls/active')) {
				emitter.emit('openDetailsModal', {
					view: 'manageKPI',
					title: row.controlTitle || row.title || 'Control',
					params: { controlId: row._id, type: 10102 },
				});
			}
			else if (this.$route.path.includes('/root-Frameworks')) {
				this.$router.push({ name: 'manageRootControlMapping', params: { id: row._id }, query: { from: 'frameworks' } });
			} else if (this.$route.path.includes('/root/allControls')) {
				emitter.emit('openDetailsModal', {
					view: 'manageRootControlMap',
					title: row.title || row.controlTitle || 'Control',
					params: { controlId: row._id, from: 'internalControls' },
				});
			} else if (this.$route.path.includes('/org/findings')) {
				this.$router.push({ name: 'manageRootControlMapping', params: { id: row._id }, query: { from: 'internalControls' } });
			} else if (this.$route.path.includes('/org/controls/active')) {
				emitter.emit('openDetailsModal', {
					view: 'manageKPI',
					title: row.controlTitle || row.title || 'Control',
					params: { controlId: row._id, type: 10102 },
				});
			} else if (this.$route.path.includes('/org/system/controls')) {
				emitter.emit('openDetailsModal', {
					view: 'systemControlMapping',
					title: row.systemName || 'System',
					params: { systemId: row._id },
				});
			}
		},
		showBlockAction(data: any, index: any, coloum: any) {
			// console.log('index show block',index)
			// if(coloum == "actionButtonAtCompliance" || coloum == "actionButtonAtObjective" || coloum == "outerAction" || coloum == 'actionButtonForKPIs'){
			// 	console.log("this.showBlockindex",this.showBlockindex)
			// 	if (this.showBlockindex === index) {
			// 		this.showBlock = !this.showBlock;
			// 		console.log("this.showBlock",this.showBlock)
			// 		console.log("ïn if blockkkkkk")
			// 	} else {
			// 		console.log("showBlockindex", this.showBlockindex)
			// 		this.showBlock = true;
			// 		this.showBlockindex = index;
			// 		console.log("ïn elsee bloclk")
			// 	}
			// } else {
			if(coloum != "actionButtonAtCompliance" && coloum != "actionButtonAtObjective" && coloum != "outerAction" && coloum != 'actionButtonForKPIs'){
				this.openPopup(data, index)
			}
			// }
			
			// this.showDropdown = false;
		},
		initialize() {
			this.tableRow = this.tableRowData;
			this.searchTableRow = this.tableRowData;
		},
		paginationUpdations(currentPage: any, pageSize: any) {
			this.currentPage = currentPage;
			this.pageSize = pageSize;
		},
		sort(tableHead: any) {
			this.className = tableHead;
			if (tableHead === this.currentSort) {
				this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
			}
			this.currentSort = tableHead;
			this.classSort = this.currentSortDir === 'asc' ? 'sort_asc' : 'sort_desc';
		},
		openPopup(data: any, index: any, actionBtn: any) {
			// this.showBlockAction(data, index);
			let obj = {
				entityId: data.entityId,
				index: index
			};
			let manageKPIpopupdata = {
				entityData: data,
				indexx: index
			};
			let viewpopupdata = {
				entityData: data,
				indexx: index
			};
			let manageControlMappopupdata = {
				entityData: data,
				indexx: index
			};
			let internalControlsPopup = {
				entityData: data,
				indexx: index
			};
			let frameworksPopup = {
				entityData: data,
				indexx: index
			};
			let objectivePopup = {
				entityData: data,
				indexx: index
			};
			let activeControlPopup = {
				entityData: data,
				indexx: index
			};
			let rootControlsPopup = {
				entityData: data,
				indexx: index
			};
			let findingsPopup = {
				entityData: data,
				indexx: index
			};
			let allFindings = {
				entityData: data,
				indexx: index
			};
			let controlMappingData = {
				entityData: data,
				indexx: index
			};
			let SystemData={
				activeData:data,
				indexx:index
			};
			let allFindingsTasks = {
				entityData: data,
				indexx: index
			};
			let allComplianceView = {
				entityData: data,
				indexx: index
			};
			let ActivityData={
                activeData:data,
                indexx:index
            };

			let rootFrameworksPopup;
			if (actionBtn) {
				rootFrameworksPopup = {
					entityData: data,
					indexx: index,
					action: actionBtn
				};
			} else {
				rootFrameworksPopup = {
					entityData: data,
					indexx: index
				};
			}
			if (this.$route.path.includes('/manageKPI') || this.$route.path.includes('/root/allKpis')) {
				emitter.emit('manageKPIpopupdata', manageKPIpopupdata);
			} else if (this.$route.path.includes('/complianceControls')) {
				emitter.emit('showKpisViewData', viewpopupdata);
			} else if (this.$route.path.includes('/viewConfiguration')) {
				emitter.emit('internalControls', internalControlsPopup);
			}
			else if(this.$route.path.includes('/org/activity/controls')){
                // this.$router.push({ name: 'findings', params: { findingId: rowData._id } });
                emitter.emit('ActivityData', ActivityData);
            }
			else if (this.$route.path.includes('/manageControlMap') || this.$route.path.includes('/manageRootControlMapping')) {
				emitter.emit('manageControlMappopupdata', manageControlMappopupdata);
			} else if (this.$route.path.includes('/org/frameworks')) {
				emitter.emit('frameworksPopup', frameworksPopup);
			} else if (this.$route.path.includes('/objective')) {
				emitter.emit('showDataObjective', objectivePopup);
			} else if (this.$route.path.includes('/org/controls/Information') || this.$route.path.includes('/controls/active')) {
				emitter.emit('activeControlPopup', activeControlPopup);
			} else if (this.$route.path.includes('/root-Frameworks')) {
				emitter.emit('rootFrameworksPopup', rootFrameworksPopup);
			} else if (this.$route.path.includes('/root/allControls')) {
				emitter.emit('rootControlsPopup', rootControlsPopup);
			} else if (this.$route.path.includes('/root/tenant/frameWorks')) {
				emitter.emit('tenenatFrameWorks', data);
			} else if (this.$route.path.includes('/viewCompliance')) {
				emitter.emit('findingsPopup', findingsPopup);
			}else if(this.$route.path.includes('/org/findings')){
				// this.$router.push({ name: 'findings', params: { findingId: rowData._id } });
				emitter.emit('allFindings', allFindings);
			}else if(this.$route.path.includes('/task/findingTasks')){
				// this.$router.push({ name: 'findings', params: { findingId: rowData._id } });
				emitter.emit('allFindingsTasks', allFindingsTasks);
			}  else if(this.$route.path.includes('/org/controls/controlMapping')|| this.$route.path.includes('/org/projects')){
				// this.$router.push({ name: 'findings', params: { findingId: rowData._id } });
				emitter.emit('controlMappingData', controlMappingData);
			} 
			else if(this.$route.path.includes('/org/activity/controls')){
				// this.$router.push({ name: 'findings', params: { findingId: rowData._id } });
				emitter.emit('ActivityData', ActivityData);
			}
			else if(this.$route.path.includes('/org/system/controls')){
				// this.$router.push({ name: 'findings', params: { findingId: rowData._id } });
				emitter.emit('SystemData', SystemData);
			}
			else if(this.$route.path.includes('/org/compliance')){
				emitter.emit('allComplianceView', allComplianceView);
			}
			else if (this.$route.path.includes('/org/viewKPIS')) {
				emitter.emit('showKpisViewData', viewpopupdata);
			}
			else {
				emitter.emit('showData', obj);
			}
			if (data.key == 10001) {
				this.$router.push({ name: 'riskName', params: { taskId: data.ID } });
			}
		},
		
		toolTip(column: any, e: any, index: any, row: any, status: any) {
			// this.tipText = row[column];
			let ValueKeys:any = ['criticality']
			if(ValueKeys.includes(column)){
				
               this.tipText = this.getCriticalityName( row[column])
            }else{
				
               this.tipText = row[column];
            }
			this.tipColumn = column;
			this.tipIndex = index;
			let effectivenessKeys:any = ['health']
			if(effectivenessKeys.includes(column)){
               const effectivenessData = this.colorEffectivenessBg( row[column])
			   this.tipText = effectivenessData?.value || 'N/A';
			//    console.log('effectivenessData',this.tipText);
            }else if(column!='criticality'){
               this.tipText = row[column];
            }

			switch (status) {
				case 'text':
					this.handleTextTooltip(e,column);
					break;
				case 'label':					
                    let ValueKeys:any = ['criticality']
                      if(ValueKeys.includes(column)){
                         const container = e.currentTarget.closest('.table-ellipsisForValue');
                          if (container && this.isTextOverflowed(container)) {
                             let obj:any = {
                                tipText : this.tipText
                            }														
                            emitter.emit('activiteToolTip',obj)
                          }
                     }
                     break;
				case 'circleButton':
					if(column === 'kpiHealth' && row.kpiHealthTooltip){
						emitter.emit('activiteToolTip', { tipText: row.kpiHealthTooltip });
					}else if(this.tipText == 1){
                           let obj:any = {
                                tipText : 'Active'  
                            }
                             emitter.emit('activiteToolTip',obj)
                    }else if(this.tipText == 2){
                           let obj:any = {
                                tipText : 'Inactive'
                            }
                             emitter.emit('activiteToolTip',obj)
                    }else {
						emitter.emit('activiteToolTip', { tipText: this.tipText });
					}
					break;
					case 'circle':
                    let findVal = this.dbSeverity.find((obj:any)=>{return obj.value == row['severity']})
                    if(findVal != undefined){
                        this.tipText = findVal.key
                    }else{
                        this.tipText = row[column]
                    }

                    let obj:any = {
                        tipText : this.tipText
                    }
                    emitter.emit('activiteToolTip',obj)
                    break
			}
		},
		handleTextTooltip(e: any,column:any) {
			const container = e.currentTarget.closest('.table-ellipsis');
			// console.log("tooltip",container)
			 if (container && this.isTextOverflowed(container)) {
				let obj:any = {
					tipText : this.tipText
				}
				emitter.emit('activiteToolTip',obj)
            }
			 else if (column === 'criticality' && container) {
                const textContent = container.textContent?.trim() || '';
                let obj:any;
                if (
                    textContent.length > 12 || this.isTextOverflowed(container)
                ) {
                    if(this.dbProcessCriticality && this.dbProcessCriticality.length>0){
                        for(let i=0;i<this.dbProcessCriticality.length;i++){
                            if(this.tipText == this.dbProcessCriticality[i].value){
                                this.tipText = this.dbProcessCriticality[i].key                    
                                obj= {
                                    tipText: this.tipText
                                };
                            }
                        }
                    }
                    emitter.emit('activiteToolTip', obj);
                }
            } 
		},
		isTextOverflowed(element: any) {
			return element.scrollHeight > element.clientHeight;
		},
		colorPriorityText(priority: any) {
			if (priority == 1) {
				return ['text-lightgreen font-semibold'];
			} else if (priority == 2) {
				return ['text-green font-semibold'];
			} else if (priority == 3) {
				return ['text-yellow font-semibold'];
			} else if (priority == 4) {
				return ['text-error font-semibold'];
			} else if (priority == 5) {
				return ['text-darkred font-semibold'];
			}
		},
		colorPriorityBg(priority: any) {
			if (priority == 1) {
				return ['bgLightGreen border-solid border border-lightgreen'];
			} else if (priority == 2) {
				return ['bgGreen border-solid border border-green'];
			} else if (priority == 3) {
				return ['bgYellow border-solid border border-yellow'];
			} else if (priority == 4) {
				return ['bgError border-solid border border-error'];
			} else if (priority == 5) {
				return ['bgdarkred border-solid border border-darkred'];
			}
		},
		colorEffectivenessBg(effective: any) {
		if (effective == null || effective === '' || effective === 'N/A') {
			return { color: '', value: 'N/A' };
		}
		if (effective == 1) {
			return { color: 'bg-darkred', value: 'Critical' };
		} else if (effective == 2) {
			return { color: 'bg-error', value: 'ILL' };
		} else if (effective == 3) {
			return { color: 'bg-yellow', value: 'Moderate' };
		} else if (effective == 4) {
			return { color: 'bg-green', value: 'Good' };
		} else if (effective == 5) {
			return { color: 'bg-lightgreen', value: 'Healthy' };
		}
		return { color: '', value: 'N/A' };
		},
		colorTaskStatusBg(status: any) {
			if (status == 'Open') {
				return ['bgLightGreen border-solid border border-lightgreen'];
			} else if (status == 'Closed') {
				return ['bgdarkred border-solid border border-darkred'];
			}
		},
		colorTaskStatusText(status: any) {
			if (status == 'Open') {
				return ['text-lightgreen font-semibold'];
			} else if (status == 'Closed') {
				return ['text-darkred font-semibold'];
			}
		},
		doFalse() {
			emitter.emit('deActiviteToolTip')
		},
		async getAllEntities(){
            this.entitiesArray = [];
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                res.data.map((obj:any)=>{
                    let a = {value:obj._id, label:obj.entityDisplayName};
                    this.entitiesArray.push(a);
                })
                             
            })
        },
        colorLabelText(value: any) {
            if (value == 1) {
                return ["text-lightgreen font-semibold"];
            } else if (value == 2) {
                return ["text-green font-semibold"];
            } else if (value == 3) {
                return ["text-yellow font-semibold"];
            } else if (value == 4) {
                return ["text-error font-semibold"];
            } else if (value == 5) {
                return ["text-darkred font-semibold"];
            }
        },
        colorLabelBg(value: any) {
            if (value == 1) {
                return ["bgLightGreen border-solid border border-lightgreen"];
            } else if (value == 2) {
                return ["bgGreen border-solid border border-green"];
            } else if (value == 3) {
                return ["bgYellow border-solid border border-yellow"];
            } else if (value == 4) {
                return ["bgError border-solid border border-error"];
            } else if (value == 5) {
                return ["bgdarkred border-solid border border-darkred"];
            }
        },
        getProirityLabel(val:any){
            if (val === 'N/A') { 
                return 'N/A'; 
            } else {
                let a = this.dbPriority.find((obj: any) => obj.value == val);
                return (val && typeof val === 'number') ? a.key : 'N/A';
            }
        },
	}
});
</script>